import level1 from "./level1";

export default {
  level1: level1,
  bidDialog: {
    notPassAudit: "O projeto não passou na auditoria. Agora você pode solicitar o reembolso do seu investimento de {fundsPaid} USDC.",
    canNowWithdraw: "Agora você pode retirar seu investimento de {fundsPaid} USDC.",
    seeTransaction: "Ver transação",
    biddingEnded: "Infelizmente, o período de lances terminou e sua oferta de registro não foi processada.",
    youHave: "Você tem",
    allocations: "alocações",
    title: "Ofereça créditos de carbono de {projectName}",
    whitelisted: "Você está na whitelist para comprar créditos de carbono do projeto {projectName} por um preço de ${listingPrice}.",
    network: "Rede",
    smartContract: "Contrato inteligente",
    price: "Preço",
    youReceive: "Você recebe",
    remainingAllocation: "Alocação restante",
    youPay: "Você paga",
    balance: "Balanço",
    gasEstimated: "Taxa de Gas (estimado)",
    bid: "Oferta",
    setSpendingCap: "Definir limite de gastos",
    bidTransaction: "Transação de oferta",
    status: "Estado",
    notWhitelisted: "Você não está na whitelist para esta oferta de crédito de carbono ou já finalizou sua alocação. Entre em contato com a equipe da Brazil Carbon para participar de futuras ofertas de crédito de carbono",
    switchNetwork: "Você precisa mudar para {requiredNetworkName} para poder comprar créditos de carbono. Este projeto está na ID de rede {projectId}, enquanto você está atualmente na ID de rede {networkId}",
    investmentTitle: "Você investiu com sucesso",
    investmentText: "Você recebeu { showAmount } { symbol }",
    investmentText2: "Você comprou com sucesso { showAmount } créditos de carbono de { name }. ",
    investmentText3: "Você também pode ver os detalhes da transação no explorador de blockchain.",
    investmentText4: "Você comprou com sucesso { showAmount } tokens de agrofloresta de { name }. ",
    wallet: "carteira",
    page: "página",
    max: "MÁX",
    unknownNetwork: "Rede Desconhecida",
    backToBid: "Voltar para o lance",
    error: "Erro",
    biddingClosed: "Leilão encerrado",
    biddingClosedText: "Infelizmente, o período de lances terminou e sua oferta de registro não foi processada.",
    hours: "h",
    minutes: "min",
    left: "restantes",
    currentBid: "Lance Atual",
    for: "por",
    insufficientFund: "Fundos insuficientes",
    placeBid: "Fazer lance",
    fullyBidAllocations: "Você já fez lances para toda a sua alocação",
    carbonCredit: "Crédito de Carbono",
    AgroforestryProducts: "Produtos de Agrofloresta"
  },
  connectButton: {
    account: "Conta",
    manageAccount: "Gerenciar Conta",
    connectWallet: "Conectar carteira",
    signedInAs: "Conectado como",
    acmeGmbH: "Acme GmbH",
    copyAddressTooltip: "Copiar endereço",
    viewOnExplorerTooltip: "Exibir no Explorer",
    myWallet: "Minha carteira",
    disconnect: "Desconectar",
    totalCredit: "Total de créditos",
    projectFunded: "Projeto financiado",
    openWallet: "Abrir carteira",
    login: "Entrar",
    loginToInvest: "Faça login para investir",
    currentYear: "Ano Atual"
  },
  connectDialog: {
    loginWithEmail: "Entrar com e-mail",
    continueWithWallet: "ou continue com uma carteira",
    login: "Entrar",
    email: "E-mail",
    password: "Senha",
    login_farmer: "Entrar como agricultor",
    title: "Conecte a carteira",
    description: "Saiba mais sobre carteiras",
    signIn: "Entrar",
    connectingWallet: "Conectando à sua carteira",
    clickConnect: "Clique em conectar no popup da sua carteira",
    selectAccount: "Selecione a conta para usar neste site.",
    ledgerSteps: {
      step1: "Conecte o dispositivo Ledger ao seu computador.",
      step2: "Digite seu PIN e acesse seu dispositivo.",
      step3: "Certifique-se de que você instalou o aplicativo Avalanche e o abriu em seu dispositivo.",
      step4: "Verifique o endereço da sua carteira no dispositivo.",
      step5: "Assine a mensagem exibida no seu Ledger para concluir o processo de login."
    },
    retry: "Tentar novamente",
    noWallets: "Sem carteiras?",
    welcome: "Bem-vindo à Brazil Carbon",
    login_investor: "Entrar como investidor",
    login_developer: "Entrar como desenvolvedor",
    continue_farmer: "Continuar como agricultor",
    continue_investor: "Continuar como investidor",
    continue_developer: "Continuar como desenvolvedor",
    back: "Voltar",
    cancel: "Cancelar",
    walletConnectTimeout: "A conexão da carteira expirou. Tente novamente.",
    walletConnectionFailed: "Não foi possível conectar sua carteira. Tente novamente.",
    invalid_cred: "Credenciais inválidas",
    loginOrSignUp: "Entrar ou cadastrar-se"
  },
  footerComp: {
    committed: "Comprometidos com",
    copyright: {
      line1: "©2023 Empresa Brasileira de Tecnologia de Carbono",
      line2: "Todos os direitos reservados. Este produto é protegido por direitos autorais e distribuído sob licenças que restringem cópia, distribuição e descompilação."
    },
    navigation: {
      helpPage: "Ajuda",
      contact: "Contato"
    },
    tagline: "Invista em projetos reais de bioeconomia no Brasil",
    copyrightNew: "© Brazil Carbon 2026",
    invest: {
      title: "Investir",
      carbonCredits: "Créditos de Carbono",
      agroforestry: "Agrofloresta"
    },
    participate: {
      title: "Participar",
      listProject: "Listar um projeto",
      partnerWithUs: "Seja nosso parceiro"
    },
    getInTouch: {
      title: "Fale conosco",
      linkedin: "LinkedIn",
      contactUs: "Contato"
    },
    privacyPolicy: "Política de Privacidade"
  },
  registerCard: {
    registerApproved: "Registro Aprovado",
    approved: "Aprovado",
    rejected: "Rejeitado",
    awaitingApproval: "Aguardando aprovação"
  },
  investCard: {
    state: "Estado",
    creditType: "Tipo de crédito",
    creditTypeOptions: {
      reforestation: "Reflorestamento",
      soilSequestration: "Sequestro de Solo",
      energyEfficiency: "Eficiência Energética",
      carbonMethaneCapture: "Captura de Metano de Carbono",
      renewableEnergyDevelopment: "Desenvolvimento de Energia Renovável",
      highPotencyGHGCapture: "Captura de GEE de Alta Potência",
      avoidDeforestation: "Desmatamento Evitado",
      community: "Comunidade",
      wasteToEnergy: "Resíduos para Energia"
    },
    tokenSymbol: "Símbolo do Token",
    balance: "Balanço",
    projectDetailsButton: "Detalhes do projeto"
  },
  ownerCard: {
    manageWallet: "Gerenciar Carteira",
    offeringState: {
      tba: "A ser anunciado",
      paused: "Pausado",
      live: "AO VIVO",
      finalized: "Finalizado",
      inactive: "Inativo",
      unsuccessful: "Mal Sucedido",
      noOffering: "Sem oferta",
      registered: "Registrado",
      registerClosed: "Registro fechado",
      pendingOffering: "Oferta pendente",
      successful: "Bem Sucedido",
      awaitingApprove: "Aguardando aprovação"
    },
    auditUnsuccess: "Auditoria malsucedida",
    awaitingApprove: "Aguardando aprovação",
    allocation: "Alocação",
    fundsRaised: "Fundos arrecadados",
    total: "Total",
    network: "Rede",
    contract: "Contrato",
    status: "Estado",
    statusValues: {
      inactive: "Inativo",
      offeringPeriod: "Período de oferta",
      lockedUntil: "Bloqueado até",
      unlocked: "Desbloqueado",
      withdrawn: "Retirado",
      unsuccessful: "Mal sucedido"
    },
    state: "Estado",
    tokenSymbol: "Símbolo do Token",
    projectDetailsButton: "Detalhes do projeto",
    auditTimeline: "Cronograma de auditoria de créditos de carbono",
    audit: "Auditoria",
    copyAddress: "Copiar endereço",
    viewOnExplorer: "Exibir no Explorer",
    auditPeriod: "Período de Auditoria"
  },
  navBar: {
    about: "Sobre",
    projects: "Projetos",
    token: "Token",
    jurisdictionCredit: "Crédito de Jurisdição",
    dashboard: "Painel de Controle",
    beta: "Beta",
    investInProjects: "Invista em Projetos",
    buyCarbonCredits: "Compre Créditos de Carbono",
    myDashboard: "Meu painel"
  },
  registerDialog: {
    tonsUpper: "Toneladas",
    agroforestry: "Agrofloresta",
    discoverOtherProjects: "Descubra outros projetos",
    connectedWallet: "Carteira conectada",
    walletAddress: "Endereço da carteira",
    registration: "Registro",
    businessName: "Nome da empresa",
    required: "Este campo é obrigatório",
    businessNameMaxLength: "O nome da empresa deve ter no máximo 255 caracteres",
    maxSupplyText: "Todos os créditos de carbono para este projeto foram alocados; explore outros projetos para oportunidades disponíveis.",
    fullName: "Nome Completo",
    fullNameMaxLength: "O nome completo deve ter no máximo 255 caracteres",
    businessIncorporationDate: "Data de incorporação da empresa",
    dateInvalid: "Insira uma data válida no formato DD-MM-AAAA",
    yearMustBeCurrentOrEarlier: "A data deve ser hoje ou anterior.",
    email: "E-mail",
    emailInvalid: "Insira um endereço de e-mail válido",
    oneCreditEquals: "1 crédito = {price} USDC",
    maxSupply: "Suprimento máximo: {maxSupply}",
    maxSupplyTitle: "Créditos de Carbono Totalmente Alocados",
    amountGreater: "O valor deve ser maior que 0.",
    amountMaxSupply: "O valor deve ser menor ou igual ao suprimento disponível.",
    walletAddressInvalid: "Insira um endereço de carteira válido",
    pasteWallet: "Cole o endereço da carteira conectada",
    connectWallet: "Conecte sua carteira para colar seu endereço",
    verification: "Verificação",
    amlCheck: "Verificação de AML",
    performingAmlCheck: "Executando a verificação de AML...",
    amlCheckPassed: "Verificação de AML aprovada com sucesso!",
    back: "< Voltar",
    continue: "Continuar",
    register: "Registre-se",
    toBeAnnounced: "Preço a ser anunciado",
    registerClosed: "Inscrições encerradas",
    onlyRegisteredBid: "Apenas compradores registrados podem dar lances",
    offerFinalized: "Oferta finalizada",
    youAreRegisteredTitle: "Você está registrado!",
    youRequested: "você solicitou",
    credits: "créditos",
    changeAllocation: "Alterar minha alocação",
    unableApprove: "Não foi possível Aprovar",
    unableApproveText: "Após uma consideração cuidadosa, lamentamos informar que não podemos aprovar sua solicitação neste momento",
    registerEnded: "Inscrição encerrada",
    sendEmail: "Nós lhe enviaremos um e-mail assim que a venda começar",
    registerSale: "Registrar para a venda",
    information: "Informações",
    amount: "Quantidade",
    available: "disponível",
    carbonCredit: "Crédito de Carbono",
    AgroforestryProducts: "Produtos de Agrofloresta",
    creditsCapital: "Créditos",
    carbonCredits: "Créditos de Carbono",
    agroProducts: "Produtos de agrofloresta",
    verifying: "Verificando",
    verifyingText: "Pode levar até um minuto. Nós retornaremos em breve!",
    verifyingButton: "Registro enviado",
    insufficientFund: "Fundos insuficientes",
    submit: "Enviar",
    logo: "Logotipo da Empresa",
    webPage: "URL do Site",
    companyRegistryNumber: "Número de Registro da Empresa",
    dateOfIncorporation: "Data de Constituição",
    phone: "Número de Telefone",
    invalidUrl: "Insira uma URL válida (ex.: https://example.com)",
    companyRegistryMaxLength: "O número de registro da empresa deve ter no máximo 50 caracteres",
    invalidPhone: "Insira um número de telefone válido"
  },
  networkButton: {
    networkIconAlt: "Ícone de rede",
    mainnetsTab: "Redes",
    testnetsTab: "Testes",
    switchNetwork: "Rede de computadores"
  },
  withdrawComp: {
    unlockedFunds: "Desbloqueados",
    nextUnlock: "Próximo desbloqueio",
    withdraw: "Retirar",
    withdrawWithAmount: "Retirar ${remainingFundsUnlocked}",
    usdcCommission: "Comissão em USDC",
    creditCommission: "Comissão em Créditos"
  },
  contactPage: {
    contactUs: "Entre em contato conosco"
  },
  projectsPage: {
    title: "Explore projetos de qualidade",
    allProjectsTitle: "Todos os Projetos",
    registerClosed: "Registro fechado",
    registered: "registrado",
    noCreditsAvailable: "Não há mais créditos disponíveis!",
    totalCredits: "créditos no total",
    pricePerTon: "/tonelada de CO₂e",
    bid: "Oferta",
    register: "Registre-se",
    offeringFinalized: "Oferta finalizada",
    offeringCreated: "Oferta criada.",
    participantsWhitelisted: "Participantes na whitelist.",
    upcomingOffering: "Oferta futura",
    allocated: "Alocado",
    total: "Créditos totais",
    startRefund: "Iniciar Reembolso",
    withdraw: "Retirar",
    withdrawn: "Retirado",
    paused: "Pausado",
    landHectaresTitle: "1,2k",
    landHectaresText: "Hectares",
    carbonCreditsTitle: "12M",
    carbonCreditsText: "Créditos",
    lockedValueTitle: "$2,3M",
    lockedValueText: "Valor oferecido",
    registry: "Registro",
    carbonTitle: "Invista em créditos de carbono de alta integridade",
    agroTitle: "Invista em sistemas alimentares antifrágeis",
    tabs: {
      carbon: "Créditos de Carbono",
      agroforestry: "Agrofloresta"
    }
  },
  projectDetail: {
    changeLocation: "Alterar local",
    projectDesignDocument: "Documento de Design do Projeto",
    projectFeasibilityReport: "Relatório de Viabilidade do Projeto",
    developer: "Desenvolvedor",
    certifiedBy: "Certificado por",
    type: "Tipo:",
    state: "Estado:",
    bid: "Oferta",
    offeringFinalized: "Oferta finalizada",
    offeringCreated: "Oferta criada.",
    participantsWhitelisted: "Participantes whitelist",
    upcomingOffering: "Oferta futura",
    overview: "Resumo",
    biodiversity: "Biodiversidade",
    flora: "Flora",
    fauna: "Fauna",
    endangeredAnimals: "Animais em Perigo",
    species: "espécies",
    files: "Documentos",
    photos: "Fotos",
    download: "Baixar",
    paused: "Pausado",
    offeringPaused: "Oferta pausada",
    seeAllPhotos: "Ver todas as fotos",
    fileName: "Arquivo",
    location: "Localização",
    category: "Categoria",
    completed: "Financiamento concluído",
    auditUnsuccesful: "Auditoria malsucedida",
    cantParticipate: "Desculpe. Você não pode participar desse projeto",
    applyToGetRefund: "Solicitar reembolso",
    requestAccepted: "Solicitação aceita",
    canWithdraw: "Agora você pode retirar seu USDC",
    alreadyWithdwan: "Quantia retirada",
    withdrawnText: "Você retirou {usdcAmount} USDC",
    registerForSale: "Registrar para venda",
    fundingCollected: "Financiamento Coletado",
    fundingTarget: "Meta de Financiamento",
    totalAreaHectares: "{project_area_hectares} hectares",
    partner: "Parceiro"
  },
  wallet: {
    owned: "Projetos próprios",
    invested: "Projetos investidos",
    registered: "Projetos registrados"
  },
  confirmDialog: {
    deleteProjectTitle: "Excluir projeto",
    deleteProjectContent: "Tem certeza de que deseja excluir este projeto?",
    deleteDraftTitle: "Excluir rascunho",
    deleteDraftContent: 'Tem certeza de que deseja excluir "{name}"?',
    confirm: "Confirmar",
    cancel: "Cancelar",
    deleteWarning: "Esta ação não pode ser desfeita."
  },
  labels: {
    successful: "Bem Sucedido",
    unsuccessful: "Mal Sucedido",
    startAudit: "Iniciar Auditoria",
    windowNotOpen: "Janela de Auditoria Não Aberta",
    auditSuccess: "Auditoria Bem Sucedida",
    cancelUnsuccessful: "Cancelar Auditoria Mal Sucedida",
    days: "dias",
    day: "dia",
    auditorProjects: "Projetos do Auditor",
    developerProjects: "Projetos do Desenvolvedor",
    developerDrafts: "Projetos de carbono em rascunho",
    developerCarbonDrafts: "Rascunhos de financiamento de carbono",
    developerListedCreditDrafts: "Rascunhos de créditos listados",
    noDeveloperDrafts: "Você ainda não tem rascunhos salvos.",
    resumeDraft: "Continuar rascunho",
    draftStep: "Etapa {step}",
    draftStatus: "Estado: {status}",
    lastSaved: "Último salvamento {date}",
    addProject: "Criar um novo projeto",
    audits: "Auditorias",
    partnerProjects: "Projetos do Parceiro"
  },
  developerPage: {
    hectares: "Hectares",
    projectType: "Tipo de Projeto",
    step1Title: "Detalhes do Projeto",
    step2Title: "Arquivos do Projeto",
    resultTitle: "Resultados",
    addProjectFiles: "Adicionar Arquivos do Projeto",
    uploadProjectPhotos: "Enviar Fotos do Projeto (Máx. 16 JPG, JPEG ou PNG)",
    uploadForestPhoto: "Enviar Foto da Cobertura Florestal (Máx. 1 JPG, JPEG ou PNG)",
    uploadProjectFiles: "Enviar Arquivos do Projeto (Máx. 4 PDF)",
    photosUploading: "Enviando Fotos...",
    filesUploading: "Enviando Arquivos...",
    upload: "Enviar",
    progress: "Progresso",
    results: "Resultados",
    projectData: "Dados do Projeto",
    noPhotos: "Não",
    images: "imagens",
    projectPhotos: "Fotos do Projeto",
    projectFiles: "Arquivos do Projeto",
    noFiles: "Não",
    pdfs: "PDFs",
    noFileUploaded: "Nenhum arquivo enviado",
    back: "Voltar",
    continue: "Continuar",
    backToProjectsList: "Voltar para a Lista de Projetos",
    finished: "Concluído!",
    nameForText: "Nome do Projeto",
    auditor: "Auditor do Projeto",
    state: "Selecionar Estado do Brasil",
    carbonCreditSupply: "Fornecimento de Crédito de Carbono",
    listingPrice: "Preço de Listagem",
    overview: "Visão Geral",
    biodiversity: "Biodiversidade",
    floraCount: "Quantidade de Espécies de Flora",
    faunaCount: "Quantidade de Espécies de Fauna",
    endangeredSpeciesCount: "Quantidade de Espécies Ameaçadas",
    userNotAuthenticated: "Usuário não autenticado",
    summary: "Resumo do Projeto",
    commission: "Comissão do Desenvolvedor em USD",
    creditCommission: "Comissão do Desenvolvedor em Crédito de Carbono",
    calcReddCost: "Calcular custo REDD+",
    auditorVerification: "Auditor para Verificação",
    auditorValidation: "Auditor para Validação",
    projectDeveloper: "Desenvolvedor do Projeto",
    projectCertifier: "Certificador do Projeto",
    selectBrazilState: "Selecionar Estado do Brasil",
    inflationRate: "Taxa de Inflação",
    projectCoBenefitors: "Co-Beneficiários do Projeto",
    landOwner: "Proprietário da Terra",
    forestCover: "Cobertura Florestal",
    yearsPeriod: "Duração do Projeto em Anos",
    investorsPercent: "Investidores (%)",
    ownersPercent: "Proprietários (%)",
    developersPercent: "Desenvolvedor (%)",
    platformPercent: "Plataforma (%)",
    stakersPercent: "Detentores de participação (%)",
    historicalDeforestationRate: "Taxa Histórica de Desmatamento (0-1 escala)",
    carbonSequestrationRate: "Taxa de Sequestro de Carbono (toneladas/ano)",
    deforestationDrivers: "Fatores de Desmatamento",
    deforestationAgents: "Agentes de Desmatamento",
    ecosystemServicesValuation: "Valoração dos Serviços do Ecossistema",
    biomeAreaHectares: "Área do Bioma (hectares)",
    auditorFee: "Taxa do Auditor (%)",
    auditCost: "Custo da Auditoria",
    tokenName: "Nome do Token",
    tokenSymbol: "Símbolo do Token",
    registerAsDeveloper: "Registrar-se como desenvolvedor",
    numberCarbonCredits: "Número de Créditos de Carbono"
  },
  validation: {
    fieldRequired: "Este campo é obrigatório",
    required: "{field} é obrigatório."
  },
  projectStates: {
    projectDesign: "Desenho do Projeto",
    validation: "Validação",
    registration: "Registro",
    monitoring: "Monitoramento",
    verification: "Verificação",
    certifiedEmissionReduction: "Emissão",
    offering: "Oferta",
    liveOffering: "Oferta ao Vivo",
    finalizedOffering: "Oferta Finalizada",
    audit1: "Auditoria 1",
    audit2: "Auditoria 2",
    audit3: "Auditoria 3",
    audit4: "Auditoria 4",
    audit5: "Auditoria 5",
    audit: "Auditoria",
    projectCycle: "Ciclo de Vida",
    credits: "créditos",
    feasibilityAssessment: "Avaliação de viabilidade"
  },
  errors: {
    errorEnterName: "Por favor, preencha o campo de nome.",
    errorOccrred: "Ocorreu um erro inesperado, por favor tente novamente mais tarde.",
    insuffFunds: "Fundos insuficientes para gás.",
    fillRequiredFields: "Por favor, preencha todos os campos obrigatórios.",
    validDate: "Por favor, insira uma data válida no formato DD-MM-YYYY",
    currentOrEarlierDate: "A data deve ser atual ou anterior",
    validEmail: "Por favor, insira um endereço de email válido",
    invalidWalletAddress: "Endereço Ethereum inválido. Verifique e tente novamente",
    amountGreaterThanZero: "A quantidade deve ser maior que 0",
    failedToRegister: "Falha ao registrar. Por favor, tente novamente.",
    blacklistedWallet: "Endereço de carteira na lista negra. Contate o suporte.",
    cannotGetContractAddress: "Não foi possível obter o endereço do contrato.",
    withdrawalFailed: "Falha ao retirar. Por favor, tente novamente.",
    metamaskNotDetected: "A extensão MetaMask não foi detectada. Por favor, instale o MetaMask para continuar.",
    metamaskLockedOrOtherWalletActive: "O MetaMask está bloqueado ou outra extensão de carteira está ativa. Por favor, desbloqueie o MetaMask e desative outras extensões de carteira.",
    metamaskRequestPending: "Já existe uma solicitação de permissão pendente no MetaMask. Abra a extensão e conclua ou cancele o pedido anterior.",
    connectingMetamask: "Erro ao conectar ao MetaMask: {message}",
    connectingLedger: "Erro ao conectar ao Ledger: {message}",
    failedToGetLedgerPublicKey: "Falha ao obter a chave pública do dispositivo Ledger.",
    transactionCanceled: "Você cancelou a transação.",
    tokenBurningFailed: "Erro ao queimar tokens",
    tokenWithdrawalFailed: "Erro ao retirar tokens",
    walletBlacklisted: "O endereço da carteira está na lista negra. Contate o suporte.",
    updateProjectFailed: "Erro ao atualizar o projeto.",
    uploadPhotosAndDocuments: "Por favor, faça o upload de fotos e documentos antes de prosseguir.",
    selectLocationOnMap: "Por favor, selecione uma localização no mapa.",
    submitFormFailed: "Erro ao enviar o formulário.",
    auditorCoverageMissing:
      "Nenhum auditor está configurado para projetos agroflorestais nesta região. Peça a um administrador para adicionar cobertura de auditoria antes de enviar.",
    obtainProjectIdFailed: "Falha ao obter o ID do projeto. A criação do projeto pode ter falhado.",
    uploadFilesOrPhotosFailed: "Erro ao fazer upload de arquivos ou fotos.",
    selectAtLeastOnePhoto: "Você deve selecionar pelo menos 1 foto.",
    noCachedPhotos: "Nenhuma foto em cache encontrada.",
    photoUploadFailed: "Upload de fotos não bem-sucedido: {reason}",
    selectAtLeastOneFile: "Você deve selecionar pelo menos 1 arquivo.",
    noCachedFiles: "Nenhum arquivo em cache encontrado.",
    fileUploadFailed: "Upload de arquivos não bem-sucedido: {reason}",
    createProjectFailed: "Falha ao criar o projeto.",
    walletAddressAlreadyRegistered: "O endereço da carteira já foi registrado neste projeto",
    auditStartFailed: "Falha ao iniciar a auditoria!",
    auditConfirmFailed: "Falha ao confirmar a auditoria!",
    auditPauseFailed: "Falha ao pausar a auditoria!",
    auditCancelFailed: "Não é possível cancelar a auditoria sem sucesso",
    auditCancelFailedTokens: "Não é possível cancelar a auditoria malsucedida. Tokens já queimados",
    cantChangeAllocations: "Erro ao alterar alocações. Por favor, tente novamente mais tarde",
    enterProjectName: "Por favor, insira o nome do projeto.",
    selectProjectType: "Por favor, selecione o tipo de projeto.",
    selectState: "Por favor, selecione um estado.",
    enterAuditorValidation: "Por favor, selecione um auditor para validação.",
    enterAuditorVerification: "Por favor, selecione um auditor para verificação.",
    enterForestCoverInfo: "Por favor, insira as informações de cobertura florestal.",
    selectProjectDuration: "Por favor, selecione a duração do projeto em anos.",
    enterHistoricalDeforestationRate: "Por favor, insira a taxa histórica de desmatamento.",
    enterCarbonSequestrationRate: "Por favor, insira a taxa de sequestro de carbono.",
    enterDeforestationDrivers: "Por favor, descreva os vetores de desmatamento.",
    enterDeforestationAgents: "Por favor, liste os agentes de desmatamento.",
    enterEcosystemServicesValuation: "Por favor, forneça a valoração dos serviços ecossistêmicos.",
    enterBiomeArea: "Por favor, insira a área do bioma em hectares.",
    enterProjectArea: "Por favor, insira a área do projeto em hectares.",
    selectLandTenureStatus: "Por favor, selecione o status da posse da terra.",
    selectBiome: "Por favor, selecione o bioma.",
    enterProjectGoal: "Por favor, insira uma visão geral do projeto.",
    enterProjectSummary: "Por favor, forneça informações sobre a biodiversidade do projeto.",
    enterTokenSupply: "Por favor, insira o fornecimento total de tokens.",
    enterListingPrice: "Por favor, insira o preço de listagem do token.",
    enterTokenName: "Por favor, insira um nome para o token.",
    enterTokenSymbol: "Por favor, insira um símbolo para o token (ex.: ECO).",
    allocationIsNone: "A alocação está vazia",
    allocationSumTooHigh: "A soma das alocações não pode ser maior que 100",
    allocationSumTooLow: "A soma das alocações está abaixo de 100",
    addOwnersOrZero: "Adicione proprietários para cobrir as alocações ou defina a alocação como 0",
    invalidOwnerAllocation: "Por favor, insira números válidos nos campos de alocação",
    ownerAllocationTooHigh: "As alocações dos proprietários não podem exceder {percent}",
    ownerAllocationTooLow: "As alocações dos proprietários estão abaixo de {percent}",
    mintingFailed: "Erro ao criar o projeto na blockchain.",
    projectCreationFailed: "Erro na criação do projeto",
    activityNameRequired: "O nome da atividade é obrigatório.",
    activityIconRequired: "Selecione um ícone para cada atividade.",
    activityDescriptionRequired: "A descrição é obrigatória.",
    oneSentenceDescription: "Por favor, escreva apenas uma frase terminando com ponto final, ponto de exclamação ou ponto de interrogação.",
    enterAtLeastOneActivity: "Por favor, insira pelo menos uma atividade antes de continuar.",
    selectCertificationNumber: "Por favor, insira o número da certificação.",
    selectCertificationBody: "Por favor, insira o órgão certificador.",
    selectCertificationReport: "Por favor, insira a URL do relatório de certificação.",
    selectIssuanceDate: "Por favor, insira a data de emissão.",
    selectCertifier: "Por favor, selecione o certificador.",
    auditNotConfirmed: "A auditoria não foi confirmada como bem-sucedida pelo auditor.",
    filesUploadFailed: "Falha no upload dos arquivos: {response}",
    projectCreateFailed: "Falha ao criar o projeto.",
    projectIdFailed: "Falha ao obter o ID do projeto. A criação do projeto pode ter falhado.",
    projectUpdateFailed: "Falha ao atualizar o projeto.",
    selectProjectAuditor: "Por favor, selecione o auditor do projeto."
  },
  success: {
    allocationChanged: "Alocações foram alteradas",
    registrationReceived: "Seu pedido de registro foi recebido com sucesso, obrigado!",
    registeredSuccessfully: "Você se registrou com sucesso",
    registeredSuccessfullyMore: "Todas as alocações para esta oferta foram preenchidas. No entanto, se outros usuários que estão em análise não forem aceitos, você poderá receber até a quantidade que solicitou.",
    withdrawalSuccessful: "Retirada bem-sucedida! Seu saldo foi atualizado.",
    tokensBurned: "Tokens queimados com sucesso",
    tokensWithdrawn: "Tokens retirados com sucesso",
    photosCached: "Fotos em cache com sucesso.",
    photosUploaded: "Fotos foram carregadas com sucesso.",
    filesCached: "Arquivos em cache com sucesso.",
    filesUploaded: "Arquivos do projeto carregados com sucesso.",
    projectUpdated: "Projeto atualizado.",
    projectCreated: "Projeto criado no banco de dados.",
    auditStarted: "Auditoria iniciada com sucesso!",
    auditConfirmed: "Auditoria confirmada com sucesso!",
    auditPaused: "Auditoria pausada com sucesso!",
    auditCanceled: "Auditoria cancelada com sucesso!"
  },
  scrollTop: {
    scrlTop: "Rolar para o topo"
  },
  indexPage: {
    parallax: {
      title1: "Alta Integridade",
      title2: "Créditos de Carbono do Brasil",
      description: "Transparente, Confiável e Construído para Ação Climática"
    },
    ourDevelopers: "Nossos Desenvolvedores",
    scalingTitle: "Transformando o Mercado de Créditos de Carbono no Brasil",
    scalingDescription: "Conectando empresas com projetos locais certificados para compensar emissões facilmente e criar uma mudança real. Com total transparência e acesso simplificado, todos se beneficiam—esta é a redução de emissões feita da maneira certa!",
    scalingItem1Title: "50 M",
    scalingItem1Description: "Hectares protegidos do desmatamento",
    scalingItem2Title: "15%",
    scalingItem2Description: "Do potencial de sequestro de carbono do Brasil",
    scalingItem3Title: "$300B",
    scalingItem3Description: "Potencial de mercado até 2050",
    scalingItem4Title: "8.5 M",
    scalingItem4Description: "Oportunidades de emprego",
    scalingItem5Title: "15x",
    scalingItem5Description: "Crescimento projetado ao longo de 10 anos",
    howWorks: {
      title: "Como funciona",
      step: "Passo",
      itemTitle1: "Sensoriamento remoto e análise do solo",
      itemDescription1: "Calculamos os créditos de carbono comparando dados de sensoriamento remoto e análise do solo.",
      itemTitle2: "Créditos de carbono como tokens",
      itemDescription2: "Para digitalizar os créditos de carbono, os emitimos como tokens na blockchain.",
      itemTitle3: "Leilões como contratos inteligentes",
      itemDescription3: "Os tokens são enviados para um contrato inteligente de leilão que aceita lances por eles.",
      itemTitle4: "Auditorias periódicas",
      itemDescription4: "Os fundos são bloqueados por um número específico de anos, durante os quais o emissor dos créditos pode reivindicar uma parte dos fundos após cada auditoria bem-sucedida.",
      descriptionTitle1: "Garantia de",
      descriptionTitle2: "Proteção",
      descriptionText1: "Garantimos que seu investimento está totalmente protegido. Se uma auditoria falhar, você pode devolver o crédito de carbono para um reembolso ou solicitar compensação diretamente de nossa reserva de créditos de carbono—sua segurança é garantida em cada passo do caminho.",
      descriptionText2: "Solicite compensação diretamente de nossa reserva de créditos de carbono—sua segurança é garantida em cada passo do caminho.",
      descriptionText: "Se uma auditoria falhar, você pode devolver o crédito de carbono para um reembolso ou solicitar compensação diretamente de nossa reserva de créditos de carbono—sua segurança é garantida em cada passo do caminho.",
      descriptionTitle: "Garantimos que seu investimento está totalmente protegido."
    },
    featuredProjects: {
      title: "Projetos em destaque",
      seeAll: "Ver todos",
      description: "Interessado em destacar seu projeto?",
      link: "Entre em contato para se tornar um parceiro hoje"
    },
    testimonials: {
      title: "Depoimentos",
      role1: "Proprietário do projeto",
      role2: "Desenvolvedor",
      role3: "Designer"
    },
    auditsBy: {
      title: "Auditado por"
    },
    forYou: {
      title: "Feito para agricultores e desenvolvedores",
      tabs: {
        farmers: "Para Agricultores",
        developers: "Para Desenvolvedores"
      },
      farmers: {
        card1: "Registro de terra verificado por satélite",
        card2: "Financiamento sem burocracia",
        card3: "Pagamentos diretos na sua carteira",
        card4: "Dinheiro para expandir e melhorar sua propriedade",
        card5: "Você só deposita — nós cuidamos de todos os pagamentos",
        card6: "Retornos que crescem com a sua colheita real",
        feature1: "Registro de terra verificado por satélite",
        feature2: "Financiamento sem burocracia",
        feature3: "Pagamentos diretos na sua carteira",
        feature4: "Dinheiro para expandir e melhorar sua propriedade",
        feature5: "Você só deposita — nós cuidamos de todos os pagamentos",
        feature6: "Retornos que crescem com a sua colheita real"
      },
      developers: {
        card1: "Lance novos projetos em minutos, não em meses",
        card2: "Precificação inteligente embutida para cada estágio",
        card3: "Documentação do projeto gerada automaticamente",
        card4: "Marketplace integrado para alcançar investidores verificados",
        card5: "Monitoramento e verificação por satélite, prontos para usar",
        card6: "Ferramentas completas de orçamento e financiamento",
        feature1: "Lance novos projetos em minutos, não em meses",
        feature2: "Precificação inteligente embutida para cada estágio",
        feature3: "Documentação do projeto gerada automaticamente",
        feature4: "Marketplace integrado para alcançar investidores verificados",
        feature5: "Monitoramento e verificação por satélite, prontos para usar",
        feature6: "Ferramentas completas de orçamento e financiamento"
      }
    },
    faq: {
      title: "FAQ",
      questionTitle1: "Como posso comprar um crédito de carbono na plataforma?",
      questionDescription1: "Você precisa se registrar para uma oferta de crédito de carbono em um dos projetos. Assim que a oferta começar, você receberá uma notificação por e-mail informando que pode prosseguir com a compra dos créditos de carbono.",
      questionTitle2: "Como faço para me registrar em uma oferta de crédito de carbono?",
      questionDescription2: "Para se registrar, siga estas etapas:\n• Navegue até a página de Projetos, onde você encontrará uma lista de projetos de crédito de carbono disponíveis.\n• Clique no botão \"Registrar\" ao lado do projeto em que você gostaria de participar.\n• Preencha as informações necessárias: nome da empresa, data de fundação, nome completo, endereço da carteira e a quantidade de alocações que você deseja adquirir.\n• Após enviar seu registro, você receberá um e-mail confirmando que sua solicitação está sendo analisada. Nossa equipe verificará a legitimidade dos seus dados antes de aprovar sua solicitação.",
      questionTitle3: "Quais são os requisitos para participar das ofertas de crédito de carbono?",
      questionDescription3: "Para participar das ofertas de crédito de carbono, você precisa:\n• Registrar-se na plataforma fornecendo os detalhes da sua empresa, endereço da carteira e a quantidade de créditos que deseja comprar.\n• Ter uma conta aprovada após a verificação do seu registro por nossa equipe.\n• Garantir que você tenha a quantidade necessária de USDC na sua carteira conectada, pois todos os pagamentos são processados por contratos inteligentes utilizando USDC.\n• Você não pode dar lances por mais do que a quantidade alocada durante o processo de registro.",
      questionTitle4: "Onde posso ver os créditos de carbono que comprei?",
      questionDescription4: "Após fazer um lance com sucesso em créditos de carbono e a transação ser confirmada, você receberá os créditos na sua carteira. Você pode visualizar esses créditos:\nNa sua carteira conectada, como a MetaMask ou outra carteira compatível, após importar o endereço do contrato do token. Recomendamos fortemente o uso de uma carteira Ledger para transações de alto volume, para maior segurança.\nNa página de Painel, suas alocações e créditos restantes serão exibidos na sua conta.",
      questionTitle5: "Posso fazer transferências bancárias durante o pagamento?",
      questionDescription5: "Não, a plataforma suporta apenas pagamentos via tokens USDC através de uma carteira conectada. Transferências bancárias ou transações em moeda fiduciária não são suportadas neste momento.",
      questionTitle6: "Como posso ver se um projeto foi malsucedido?",
      questionDescription6: "Você receberá notificações por e-mail se o projeto em que você participou encontrar problemas. Além disso, o status do projeto será atualizado no seu Painel.",
      questionTitle7: "Se um projeto falhar após alguns anos, como posso obter um reembolso?",
      questionDescription7: "Se um projeto falhar durante uma das auditorias, você pode iniciar um reembolso devolvendo seus créditos de carbono ao contrato inteligente:\nVocê poderá enviar os créditos de carbono comprados de volta ao contrato. Para isso, acesse a página de detalhes do projeto com sua carteira conectada. Se uma auditoria foi malsucedida, você verá o botão \"Solicitar reembolso\". Clique nesse botão e confirme a transação na sua carteira.\nAssim que os créditos forem recebidos, você verá o botão \"Retirar\". Clique nesse botão e confirme a transação na sua carteira. O contrato inteligente queimará automaticamente os tokens, e você receberá um reembolso em USDC, proporcional ao tempo restante após a falha da auditoria, menos as comissões aplicáveis.\nVocê também será notificado por e-mail sobre o processo de reembolso, com instruções de como completar a transação.",
      questionTitle8: "A tokenização de créditos de carbono é legalmente reconhecida?",
      questionDescription8: "Embora a tokenização ainda não seja especificamente regulamentada no Brasil, a venda de créditos de carbono continua sendo reconhecida dentro do mercado voluntário de carbono. A tokenização é uma inovação tecnológica que visa facilitar a negociação desses créditos, e sua aceitação legal depende da conformidade com as normas ambientais e da transparência para garantir a validade dos ativos tokenizados.",
      questionTitle9: "A empresa oferece garantias legais sobre a validade dos créditos de carbono tokenizados?",
      questionDescription9: "Sim, a empresa garante que os créditos de carbono tokenizados foram verificados e validados por padrões reconhecidos.",
      questionTitle10: "Como é garantida a autenticidade e validade dos créditos de carbono tokenizados?",
      questionDescription10: "A autenticidade e validade dos créditos de carbono tokenizados são garantidas por meio de verificação e certificação de entidades independentes e padrões internacionalmente reconhecidos. Além disso, a tecnologia blockchain garante a rastreabilidade e imutabilidade das transações, proporcionando maior segurança legal para as partes envolvidas.",
      questionTitle11: "A tokenização de créditos de carbono é legalmente reconhecida no Brasil?",
      questionDescription11: "A tokenização de créditos de carbono no Brasil ainda não é diretamente regulamentada, mas dentro do mercado voluntário, seu uso é permitido. A tokenização facilita a negociação e o rastreamento desses ativos através da tecnologia blockchain, seguindo padrões reconhecidos internacionalmente."
    },
    ourPartners: "Nossos Parceiros",
    hectaresBanner: {
      unit: "hectares",
      pipeline: "124000 ha de projetos financiados"
    },
    hero: {
      title: "Invista em projetos reais de bioeconomia no Brasil",
      subtitle: "Investimento por etapas com marcos verificados e proteção de capital integrada. Local, baseado em dados e transparente por design.",
      exploreProjects: "Explorar projetos",
      listProject: "Listar um projeto"
    },
    listProjectDialog: {
      title: "Listar um projeto",
      subtitle: "Continuar como",
      connectDeveloper: "Conectar como Desenvolvedor",
      connectFarmer: "Conectar como Agricultor",
      roleMismatch: "Entre com o perfil selecionado antes de listar um projeto."
    },
    productCards: {
      activeProjectsCount: "{count} projetos ativos",
      loadingProjects: "Carregando projetos",
      projectCountUnavailable: "Projetos indisponiveis",
      carbonCredits: {
        title: "Créditos de Carbono",
        description: "Créditos de carbono brasileiros verificados, emitidos localmente e tokenizados na emissão para negociação e retirada transparente e eficiente.",
        activeProjects: "12 projetos ativos"
      },
      agroforestry: {
        title: "Agrofloresta",
        description: "Sistemas agrícolas resilientes ao clima que combinam várias culturas na mesma terra, oferecendo rendimentos estáveis a longo prazo e retornos em USDC.",
        activeProjects: "12 projetos ativos"
      }
    },
    whyInvest: {
      title: "Por que investir com a Brazil Carbon?",
      tabs: {
        agroforestry: "Agrofloresta",
        carbonCredits: "Créditos de Carbono"
      },
      agroforestry: {
        feature1: "Sistemas agrícolas resilientes ao clima e à seca",
        feature2: "Múltiplas culturas na mesma terra (cacau, açaí, café, cupuaçu)",
        feature3: "Retornos de fluxo de caixa pagos em USDC",
        feature4: "Menores custos de longo prazo graças a solos mais saudáveis",
        feature5: "Mais estabilidade e rentabilidade a longo prazo do que a monocultura",
        feature6: "Apoia a biodiversidade enquanto gera renda"
      },
      carbonCredits: {
        feature1: "Créditos de carbono verificados de projetos brasileiros certificados",
        feature2: "Tokenizados on-chain para negociação transparente e eficiente",
        feature3: "Liberação de capital por etapas com verificação de marcos",
        feature4: "Proteção do investidor embutida via contratos inteligentes",
        feature5: "Auditorias periódicas de terceiros para responsabilidade contínua",
        feature6: "Acesso direto ao mercado voluntário de carbono em crescimento no Brasil"
      }
    },
    howItWorksNew: {
      title: "Como funciona?",
      step1: {
        title: "Projetos são estruturados em etapas",
        subtitle: "Cada etapa deve ser concluída e verificada antes da próxima começar."
      },
      step2: {
        title: "O capital só é liberado após a verificação",
        subtitle: "Os fundos avançam apenas quando os marcos são atingidos."
      },
      step3: {
        title: "Ativos ou receitas são distribuídos com transparência",
        subtitle: "Créditos de carbono, rendimentos ou fluxos de caixa são entregues on-chain."
      }
    },
    ecosystem: {
      title: "Nosso Ecossistema",
      investInProjects: {
        title: "Invista em projetos",
        description: "Invista diretamente em projetos de bioeconomia verificados e acompanhe o progresso em cada etapa.",
        cta: "Explorar projetos"
      },
      bctToken: {
        title: "Token BCT",
        description: "Bloqueie BCT para participar da comunidade e ganhar recompensas vinculadas a créditos de carbono e rendimentos agroflorestais reais.",
        cta: "Saiba mais"
      },
      reforestationGame: {
        title: "Jogo de Reflorestamento",
        description: "Um jogo educacional onde os jogadores restauram ecossistemas, aprendem sobre o sequestro de carbono e ganham recompensas pela participação.",
        cta: "Jogar",
        comingSoon: "Em breve"
      }
    },
    roadmap: {
      title: "Roteiro",
      q3_2025: "Investimentos em créditos de carbono tokenizados, projetos agroflorestais abertos para captação, mercado secundário de negociação permissionado.",
      q4_2025: "Cálculo de créditos de carbono multifonte (satélite + parcelas de campo + simulações de ecossistema), listagem completa de projetos para desenvolvedores, proteção de capital do investidor por etapas.",
      q1_2026: "Workflow e console de auditor independente, simulador de retornos do investidor, pipeline de desenvolvedores com gating de aprovação.",
      q2_2026: "Motor de precificação de projetos em tempo real, motores de linha do tempo e de cálculo de custos do projeto, onboarding de investidores verificados por KYC, token da plataforma e staking.",
      q3_2026: "Documentação de projeto gerada automaticamente (PDDs), workflow de seleção e geração de metodologia, integração direta com múltiplas certificadoras, primeira emissão de crédito tokenizado em produção.",
      q4_2026: "Geração de créditos de biochar com atestação por hardware, tokenização de créditos de energia, piloto de investimento em agrofloresta comunitária, rampa de entrada/saída fiat ↔ ativo digital (TradFi), negociação secundária de ativos do mundo real tokenizados."
    },
    faqNew: {
      title: "Perguntas Frequentes",
      q1: {
        title: "Como posso investir em um projeto?",
        answer: "Acesse a página Projetos, escolha um projeto e clique em Investir. Conecte sua carteira, tenha USDC disponível e confirme o valor."
      },
      q2: {
        title: "O que preciso para investir?",
        answer: "Você precisa de uma carteira digital com USDC. Para resgates futuros, será necessário realizar KYC."
      },
      q3: {
        title: "Onde vejo meus investimentos?",
        answer: "Todos os seus ativos e investimentos aparecem no dashboard e no painel lateral da plataforma."
      },
      q4: {
        title: "Posso pagar por transferência bancária?",
        answer: "Ainda não. Atualmente aceitamos apenas USDC. A integração com bancos está nos próximos passos."
      },
      q5: {
        title: "Como sei se um projeto falhou?",
        answer: "O status será exibido na página do projeto e um botão Resgatar ficará disponível."
      },
      q6: {
        title: "Como funciona o reembolso?",
        answer: "Se o projeto falhar antes de gastar os recursos, você poderá clicar em Resgatar, devolver os tokens e receber o valor restante."
      },
      q7: {
        title: "A Brazil Carbon garante os créditos de carbono?",
        answer: "A validade dos créditos é responsabilidade dos certificadores, que seguem metodologias reconhecidas."
      },
      q8: {
        title: "Carteiras digitais são seguras?",
        answer: "Sim. Elas utilizam criptografia forte e apenas quem possui as chaves privadas pode acessar os fundos."
      },
      q9: {
        title: "O que é agrofloresta?",
        answer: "É um sistema agrícola que combina árvores e culturas, gerando produção estável, maior resistência a secas e múltiplas fontes de renda."
      },
      q10: {
        title: "Como o investidor ganha dinheiro?",
        answer: "Após a venda da produção, a receita é depositada em USDC e distribuída conforme os tokens do investidor."
      },
      q11: {
        title: "O que é agrofloresta e de onde vem o valor?",
        answer: "Agrofloresta é um sistema agrícola em que culturas crescem junto com árvores, como parte de um ecossistema florestal. Culturas como cacau e café se desenvolvem melhor à sombra, tornando o sistema mais produtivo e resiliente. A agrofloresta mantém o solo saudável, retém umidade, evita químicos e produz várias culturas ao mesmo tempo, como cacau, açaí e cupuaçu. Investidores recebem retornos enquanto apoiam biodiversidade e ecossistemas saudáveis."
      },
      q12: {
        title: "Como o valor é gerado para investidores?",
        answer: "Agricultores vendem seus produtos no mercado. Após as vendas, os lucros são depositados em um contrato inteligente. Investidores reivindicam sua parte usando os tokens recebidos ao investir."
      },
      q13: {
        title: "Vocês trabalham com empresas que precisam de créditos de carbono?",
        answer: "Sim. O Brasil está introduzindo regulações que devem aumentar a demanda por créditos de carbono emitidos localmente. Também trabalhamos com empresas multinacionais que precisam de créditos para conformidade ou compensação voluntária. Os créditos podem ser vendidos em marketplaces ou aposentados."
      },
      q14: {
        title: "Empresas “queimam” créditos de carbono?",
        answer: "Sim. Créditos de carbono são aposentados pelo certificador quando usados para compensação. A Brazil Carbon não aposenta créditos; ela viabiliza investimento e acesso."
      },
      q15: {
        title: "De onde vem o rendimento dos projetos agroflorestais?",
        answer: "O rendimento vem da venda dos produtos agrícolas cultivados na propriedade, como cacau, café ou açaí. Essas vendas reais geram a receita distribuída aos investidores."
      },
      q16: {
        title: "Vocês têm um token para cada cultura?",
        answer: "Sim. Ao investir, você recebe tokens específicos por cultura. Esses tokens permitem reivindicar sua parte das receitas e também podem ser vendidos para outros investidores."
      }
    }
  },
  projectsGrid: {
    type: "Tipo",
    learnMore: "Saiba mais",
    biddingClosed: "Lances encerrados",
    biddingOpen: "Lances abertos",
    upcomingOffer: "Próxima oferta",
    by: "por",
    totalCreditsOffered: "Total de créditos oferecidos",
    certificate: "Certificado"
  },
  notFound: {
    title: "Desculpe, esta página não existe",
    description: "Procuramos em todos os lugares, mas não conseguimos encontrar o que você está procurando. Vamos encontrar um lugar melhor para você ir.",
    returnHome: "Voltar para a página inicial",
    getHelp: "Obter ajuda"
  },
  dashboardPage: {
    publicSale: "Venda pública",
    withdrawCredits: "Retirar créditos",
    investment: "Investimento",
    profit: "Lucro",
    registered: "Registrado",
    invested: "Investido",
    owned: "Próprio",
    creditsSold: "Créditos vendidos",
    myAllocation: "Minha alocação",
    myCredit: "Meu créditos",
    projects: "Projetos",
    registeredInvestors: "Investidores registrados",
    cardonCredit: "Créditos de carbono",
    projectStage: "Estágio do projeto",
    totalProjects: "Total de projetos",
    seeProjectDetails: "Ver detalhes",
    fundRaised: "Fundos arrecadados",
    creditSold: "Crédito comprado",
    nextAudit: "Próxima auditoria",
    projectEnded: "Projeto encerrado",
    unlockedFunds: "Fundos desbloqueados",
    nextUnlock: "Próximo desbloqueio",
    balance: "Saldo",
    contract: "Contrato",
    offsetting: "Compensação",
    fundsRaised: "Fundos arrecadados",
    nextAuditL: "Próxima auditoria",
    paidAmount: "Valor pago",
    creditsAllocated: "Créditos alocados",
    expectedROI: "ROI Esperado",
    investedStage: "Etapa Investida",
    fundingStage: "Etapa de Financiamento"
  },
  carbonCycle: {
    offering: "Oferta",
    registration: "Registro",
    live: "Ao vivo",
    ended: "Encerrado",
    projectDevelopment: "Desenvolvimento de Projeto",
    certification: "Certificação",
    audit: "Auditoria"
  },
  guidePage: {
    fullVideo: "Vídeo completo",
    rootBreadcrumb: "Central de ajuda do Brazil Carbon",
    howHelp: "Como podemos ajudá-lo?",
    askQuestion: "Faça uma pergunta"
  },
  multiSig: {
    alreadyApproveWithdraw: "Você já aprovou a retirada",
    alreadyApproveStartAudit: "Você já aprovou o início da auditoria",
    alreadyApproveAuditSuccess: "Você já aprovou o sucesso da auditoria",
    alreadyApproveAuditUnsuccess: "Você já aprovou a auditoria malsucedida",
    alreadyApproveCancelUnsuccess: "Você já aprovou o cancelamento da auditoria malsucedida",
    waitingApprove: "Aguardando aprovação de outros signatários",
    withdrawalOwnerSuccessful: "Retirada bem-sucedida! O saldo do proprietário foi atualizado.",
    withdrawalDeveloperSuccessful: "Retirada bem-sucedida! O saldo do desenvolvedor foi atualizado.",
    withdrawalPartnerSuccessful: "Retirada bem-sucedida! O saldo do parceiro foi atualizado."
  },
  auditorPage: {
    audits: "Auditorias",
    inProgress: "Em andamento",
    successfull: "Bem-sucedida",
    unsuccessful: "Malsucedida"
  },
  newDashboard: {
    ownedProjects: "Projetos próprios",
    allTokens: "Todos os Tokens",
    cardonCredit: "Créditos de Carbono",
    totalProjects: "Total de Projetos",
    projectsOwned: "projetos possuídos",
    projects: "Projetos",
    assets: "Ativos",
    investments: "Investimentos"
  },
  newCard: {
    certificationBody: "Órgão Certificador",
    certificateId: "ID do Certificado",
    issuanceDate: "Data de Emissão",
    creditsOwned: "Créditos Possuídos",
    certificationReport: "Relatório de Certificação",
    learnMore: "Saiba Mais",
    sell: "Vender",
    claim: "Reivindicar",
    claimBenefit: "Reivindicar benefício",
    benefitClaimSuccess: "Benefício reivindicado com sucesso",
    benefitClaimError: "Falha ao reivindicar benefício",
    availableToClaim: "Disponível para reivindicação"
  },
  sellForm: {
    selectYear: "Por favor, selecione um ano",
    unitPrice: "Preço unitário",
    owned: "Possuído",
    putOnSale: "Colocar à venda",
    enterCreditsAmount: "Digite a quantidade de créditos",
    carbonCredits: "Créditos de carbono",
    agroProducts: "Produtos de agrofloresta",
    creditsAvailable: "Créditos disponíveis",
    sell: "Vender",
    cancel: "Cancelar",
    listedOnSaleSuccess: "Listado para venda",
    listedOnSaleError: "Erro ao listar para venda"
  },
  saleSideContainer: {
    buyText: "Você comprou {showAmount} {symbol}.",
    seeTransaction: "Ver Transação",
    buyText2: "Sua compra em {name} foi bem-sucedida.",
    backToBuy: "Voltar para Comprar",
    selectYear: "Selecionar Ano",
    noTokensAvailable: "Não há tokens disponíveis para venda",
    buyVintageCredits: "Comprar créditos vintage",
    buyCredits: "Comprar créditos",
    enterUsdcAmount: "Digite o valor",
    usdcAvailable: "{amount} USDC disponíveis",
    usdc: "USDC",
    carbonCredit: "Créditos de Carbono",
    AgroforestryProducts: "Produtos de Agrofloresta",
    loginToBuy: "Faça login para comprar créditos",
    insufficientFunds: "Fundos insuficientes",
    buy: "Comprar",
    vintage: "Safra",
    buyCarbonCredits: "Comprar créditos de carbono",
    batch: "Lote",
    saleClosed: "Venda encerrada",
    saleClosedText: "Infelizmente, o período de venda terminou."
  },
  investSideContainer: {
    investmentClosed: "Investimento encerrado",
    agroQuestionTooltip: "Taxa de conversão dos produtos de agrofloresta estimados para USDC",
    questionTooltip: "Taxa de conversão de créditos estimados para créditos efetivamente emitidos",
    creditsToClaim: "Você tem {amount} créditos para reivindicar!",
    usdcToClaim: "Você tem {amount} USDC para resgatar!",
    invest: "Investir",
    loginAgain: "Entrar",
    sessionExpired: "Sua sessão expirou. Entre para continuar.",
    investmentUnavailable:
      "O investimento está temporariamente indisponível. Tente novamente mais tarde ou entre em contato com o suporte se o problema continuar.",
    roi: "{percentage}% ROI",
    certification: "certificação",
    enterUsdcAmount: "Digite o valor",
    usdcAvailable: "{amount} USDC disponíveis",
    usdc: "USDC",
    carbonCredit: "créditos de carbono",
    agroforestryProducts: "produtos de agrofloresta",
    insufficientFunds: "fundos insuficientes",
    investText: "Você investiu {showAmount} {symbol}.",
    seeTransaction: "Ver transação",
    investText2: "Seu investimento em {name} foi bem-sucedido.",
    backToInvest: "Voltar para investir",
    claimCredits: "Reivindicar créditos",
    youReceived: "Você recebeu {showAmountExchange} {symbol}",
    exchangeSuccess: "Você trocou créditos de carbono com sucesso.",
    close: "fechar",
    rate: "taxa",
    credits: "créditos",
    enterAmountUSDCWarning: "Por favor, insira primeiro o valor em USDC",
    enterAmountCreditWarning: "Por favor, insira primeiro a quantidade de créditos",
    enterAmountAgroWarning: "Por favor, insira primeiro a quantidade de agrofloresta"
  },
  overviewTab: {
    satelliteView: "Visão por satélite",
    plantingArea: "Área de plantio",
    visitMethodologyWebsite: "Visitar site da metodologia",
    description: "Descrição",
    coBenefitors: "Co-beneficiários",
    forestCoverMap: "Mapa de cobertura florestal",
    forestVisualizer: {
      unavailable: "Observação anual por satélite indisponível.",
      yearToDate: "até o momento",
    },
    developers: "Desenvolvedores",
    developedBy: "Desenvolvido por",
    certifiedBy: "Certificado por",
    files: "Arquivos",
    fileName: "Arquivo",
    location: "Localização",
    projectSize: "Tamanho do projeto",
    forestCover: "Cobertura florestal",
    methodologyApprovedBy: "Metodologia aprovada por",
    hectares: "hectares",
    hectare: "hectare",
    methodology: "Metodologia",
    projectArea: "Área do Projeto",
    partners: "Parceiros",
    notCalculatedYet: "Ainda não calculado",
    metrics: {
      project_area_ha: "Área do projeto",
      land_tenure_status: "Propriedade da terra",
      crediting_period_years: "Horizonte de modelagem",
      methodology_code: "Metodologia",
      removal_pathway: "Rota de remoção",
      country_iso: "País",
      credit_schedule_label: "Cronograma de créditos",
      methane_abatement_activity: "Atividade de mitigação",
      community_service_type: "Tipo de serviço",
      energy_asset_activity: "Ativo / atividade",
    },
    metricValues: {
      years: "{count} anos",
    },
    landownerCompensation: {
      title: "Compensação ao proprietário",
      included: "Compensação ao proprietário/co-beneficiário financiada pelo investidor está incluída como custo separado do projeto.",
      cap: "Orçamento máximo",
      monthly: "Valor mensal",
      months: "Meses",
      payoutStart: "Início do pagamento",
      allocation: "Alocação",
      projectStart: "Início do projeto",
      afterStage: "Após ano {year} {stage}",
      allocationUniform: "Distribuída entre etapas",
      allocationUpfront: "Escrow antecipado",
      refundPolicy: "A compensação já adquirida é uma despesa operacional não reembolsável. A compensação futura não adquirida permanece reembolsável conforme a política de falha do projeto."
    }
  },
  environmentTab: {
    biodiversityDescription: "Reflete a posição da área em um ranking de riqueza e diversidade de espécies.",
    biodiversityScore: "Índice de\nBiodiversidade",
    preventedDeforestation: "Desmatamento evitado\nem hectares / ano",
    ecosystemServicesValue: "Valor dos Serviços\nEcossistêmicos:",
    carbonSequestration: "Potencial de Sequestro\nde Carbono em toneladas / ano",
    deforestationCauses: "Causas do\nDesmatamento",
    deforestationContributors: "Contribuintes do\nDesmatamento",
    current: "Atual",
    forestCover: "Cobertura Florestal",
    metrics: {
      current_biomass_t: "Biomassa atual",
      biomass_uncertainty_pct: "Incerteza da biomassa",
      total_credits_forecast_tco2e: "Previsão total de créditos",
      prevented_deforestation_ha_yr: "Desmatamento evitado",
      avg_avoided_credits_forecast_tco2e_yr: "Créditos evitados / ano",
      total_co2_sequestration_forecast_tco2e: "Previsão de sequestro",
      avg_annual_sequestration_forecast_tco2e: "Sequestro / ano"
    }
  },
  carbonTab: {
    collectingFunds: "Coletando",
    totalCarbonCredits: "Total de Créditos\nde Carbono",
    finalCarbonCreditPrice: "Preço Final do Crédito\nde Carbono",
    totalCarbonCreditValuation: "Valorização Total do\nCrédito de Carbono",
    investmentPrices: "Os preços de investimento em créditos de carbono dependem da fase:",
    filled: "Preenchido",
    future: "Futuro",
    currentPhase: "Fase atual",
    current: "Atual",
    currentStage: "Estágio atual",
    invest: "Investir",
    priceText: "Preço",
    costText: "Custo",
    roiText: "ROI"
  },
  investmentTab: {
    pricePerKilo: "Preço por quilo",
    additionalRevenue: "Receita adicional total gerada",
    fundingRequirements: "Requisitos de Financiamento:",
    roi: "{value}% ROI",
    stageCostBreakdown: "Detalhamento de Custos da Etapa",
    otherCosts: "Outros",
    baseCostBreakdown: "Detalhamento do Custo Base",
    roiWithCost: "{roi}% ROI ${cost}",
    filled: "Preenchido",
    future: "Futuro",
    currentPhase: "Fase atual",
    currentStage: "Estágio atual"
  },
  roiChart: {
    inflation: "Inflação",
    total: "Total",
    cumulative: "ROI cumulativo"
  },
  auditCardNew: {
    audit: "Auditoria",
    years: "Anos",
    year: "Ano",
    stageForAudit: "Etapa para auditoria",
    startStage: "Iniciar {stageName}",
    noStageName: "Nenhum nome de etapa",
    unsuccessful: "Sem sucesso",
    successful: "Bem-sucedido",
    auditWindowOpen: "Janela de auditoria aberta",
    actionRequired: "Ação necessária",
    acceptAssignment: "Aceitar atribuição",
    releaseFunds: "Liberar recursos",
    lifecycleActions: "Ações do ciclo de auditoria",
    action: "Ação",
    stage: "Etapa",
    submitAction: "Preparar e assinar ação",
    actionCompleted: "Ação do auditor concluída.",
    amount: "Valor",
    claimId: "ID da reivindicação (bytes32)",
    evidenceHash: "Hash da evidência (bytes32)",
    bindingHash: "Hash da vinculação (bytes32)",
    planHash: "Hash do plano (bytes32)",
    payee: "Beneficiário da compensação",
    yearValues: "Anos (separados por vírgula)",
    stageIndexes: "Índices de etapa (separados por vírgula)",
    allocations: "Alocações (separadas por vírgula)",
    cap: "Limite total de compensação",
    seriesId: "ID da série",
    amountWhole: "Créditos inteiros a emitir",
    creditsWhole: "Créditos inteiros a finalizar",
    registryId: "ID do registro",
    vintageYear: "Ano da safra",
    hostCountry: "País anfitrião (bytes2)",
    capWhole: "Limite de créditos inteiros",
    registryReference: "Referência ou URL do crédito no registro",
    routeReference: "Referência da metodologia ou rota do ativo",
    creditEvidenceReference: "URL ou referência da evidência de certificação",
    confirmProjectFailure:
      "Entendo que marcar este projeto como malsucedido é irreversível.",
    creditIssuance: {
      title: "Emitir créditos — Ano {year}",
      yearBadge: "Ano {year}",
      certifier: "Certificador",
      methodology: "Metodologia",
      certifiedCredits: "Créditos a emitir (tCO₂e inteiras)",
      predictedCredits: "Preenchido pela projeção: {credits} tCO₂e inteiras. Edite antes de criar a série.",
      referencePlaceholder: "Cole uma URL, referência ou hash 0x existente",
      referenceHelp: "Use o registro público da certificação ou do registro para esta emissão.",
      registryIdHelp: "Informe o ID externo completo. O identificador compacto on-chain é gerado automaticamente.",
      registryIdRequired: "Informe o ID externo do registro ou certificado.",
      wholeCreditsRequired: "Informe uma quantidade inteira positiva de créditos.",
      exceedsSeriesCap: "A quantidade não pode exceder o limite da série.",
      registryEvidenceRequired: "Informe o ID do registro e o registro da certificação antes de emitir os créditos.",
      evidenceReferenceRequired: "Informe a URL, referência ou hash existente da evidência de certificação.",
      descriptions: {
        verifiedCreditSeriesCreate: "Confirme as evidências e crie a série on-chain.",
        creditBindingApproval: "Aprove a vinculação da série para este ano do projeto.",
        verifiedCreditIssue: "Emita os créditos verificados para a custódia de liquidação.",
        creditYearFinalize: "Finalize o ano para liberar a reivindicação na data prevista."
      }
    },
    confirmedBlock: "Confirmado no bloco {block}",
    mode: {
      auditor_required: "Carteira manual do auditor",
      backend_api: "API de auditor conectada",
      onchain: "Contrato de auditor on-chain"
    },
    modeStatus: {
      auditor_required: "As ações exigem a carteira do auditor designado.",
      backend_api:
        "O serviço de auditor conectado envia as ações. A assinatura no navegador está desativada.",
      onchain:
        "O contrato de auditor envia as ações on-chain. A assinatura no navegador está desativada."
    },
    actions: {
      stageRelease: "Liberar principal da etapa",
      projectFailure: "Marcar projeto como malsucedido",
      stageRefundFinalize: "Finalizar reembolso da etapa",
      compensationPlanConfigure: "Configurar plano de compensação",
      compensationAccrual: "Acumular compensação da etapa",
      compensationStop: "Encerrar compensação",
      creditBindingApproval: "Aprovar vinculação de crédito",
      verifiedCreditSeriesCreate: "Criar série de créditos verificados",
      verifiedCreditIssue: "Emitir créditos verificados",
      creditYearFinalize: "Finalizar ano de créditos"
    },
    releaseStage: "Ano {year}, etapa {stage}",
    waitingForFundedStage: "Aguardando uma etapa financiada.",
    waitingForDeveloperWithdrawal: "Aguardando retirada do desenvolvedor.",
    loadingStatus: "Carregando estado da auditoria…",
    preparingAction: "Preparando ação na carteira…",
    actionUnavailable: "A ação de auditoria está temporariamente indisponível.",
    auditorLoginRequired: "Entre com a carteira do auditor designado.",
    assignmentAccepted: "Atribuição do auditor aceita.",
    fundsReleased: "Recursos da etapa liberados para retirada do desenvolvedor.",
    actionPendingVerification: "Transação enviada. O estado está sendo atualizado.",
    insufficientGasFunds:
      "Sua carteira não tem ETH suficiente para pagar a taxa de rede desta ação de auditoria.",
    actionFailed: "Não foi possível concluir a ação de auditoria. Tente novamente."
  },
  AuditorPageNew: {
    inProgress: "Em andamento",
    successful: "Bem-sucedido",
    unsuccessful: "Sem sucesso",
    auditedProjects: "Projetos Auditados",
    activeAudits: "Auditorias ativas",
    waitingAuditWindow: "Aguardando janela de auditoria",
    completedAudits: "Auditorias concluídas",
    connectTitle: "Conectar carteira do auditor",
    connectDescription:
      "Conecte a carteira cadastrada pelo administrador para ver os projetos atribuídos e assinar ações de auditoria.",
    connectWallet: "Conectar carteira do auditor",
    connectHint:
      "Use o mesmo endereço de carteira configurado no cadastro do auditor.",
    connectNotRegistered:
      "Esta carteira ou este e-mail não está cadastrado como auditor. Peça a um administrador para criar o cadastro do auditor e tente novamente."
  },
  optionTabs: {
    overview: "Visão Geral",
    environment: "Meio Ambiente",
    status: "Estado",
    activities: "Atividades",
    investment: "Investimento",
    yield: "Rendimento",
    financials: "Financeiro"
  },
  stageNames: {
    design: "Desenho",
    validation: "Validação",
    monitoring: "Monitoramento",
    verification: "Verificação",
    issuance: "Emissão",
    certification: "Certificação",
    community: "Comunidade"
  },
  projectUsersStep: {
    title: "Usuários do Projeto",
    owners: "Proprietários",
    addOwner: "Adicionar Proprietário",
    removeOwner: "Remover",
    name: "Nome",
    walletAddress: "Endereço da Carteira",
    allocation: "Alocação (%)",
    coBenefitors: "Co-beneficiários",
    addBenefitor: "Adicionar Beneficiário",
    allocationOfCredits: "Alocação de créditos de carbono",
    landTenureStatus: "Status da posse da terra",
    landOwnershipStatus: "Status de Propriedade da Terra",
    landOwnershipPlaceholder: "Selecione o tipo de posse",
    landOwnershipHelper: "Adição proposta a partir das convenções brasileiras de posse da terra (CCIR/matrícula, posse, assentamento, terra indígena, quilombola, UC, concessão).",
    landStatusOptions: {
      "0": "Público",
      "1": "Privado",
      "2": "Concessão",
      private_title: "Privada",
      possession: "Posse (informal)",
      agrarian_settlement: "Assentamento de reforma agrária",
      indigenous_territory: "Terra indígena",
      quilombola: "Comunidade quilombola",
      conservation_unit: "Unidade de conservação (RPPN, APA, ...)",
      forest_concession: "Concessão florestal",
      other: "Outro (especificar)"
    },
    biome: "Bioma",
    biomeOptions: {
      "0": "Floresta Amazônica",
      "1": "Caatinga",
      "2": "Cerrado",
      "3": "Mata Atlântica",
      "4": "Pantanal",
      "5": "Pampa"
    }
  },
  createInvestForm: {
    investmentCreated: "Investimento criado com sucesso",
    basicInfo: "Informações Básicas",
    commissions: "Comissões (%)",
    usdcFee: "Taxa em USDC",
    costs: "Custos",
    year: "Ano {year}",
    supply: "Oferta",
    finalPrice: "Preço final",
    uploadPhoto: "Enviar Foto da Cobertura Florestal (Máx 1 JPG, JPEG ou PNG)",
    design: {
      title: "Desenho",
      cost: "Custo do desenho",
      description: "Descrição do desenho"
    },
    validation: {
      title: "Validação",
      cost: "Custo de Validação",
      description: "Descrição da Validação"
    },
    monitoring: {
      title: "Monitoramento",
      cost: "Custo de Monitoramento",
      description: "Descrição do Monitoramento"
    },
    verification: {
      title: "Verificação",
      cost: "Custo de Verificação",
      description: "Descrição da Verificação"
    },
    issuance: {
      title: "Emissão",
      cost: "Custo de Emissão",
      description: "Descrição da Emissão"
    },
    navigation: {
      close: "Fechar",
      back: "Voltar",
      continue: "Continuar",
      createInvest: "Criar Investimento"
    },
    startInvestmentProcess: "Iniciar processo de investimento"
  },
  errorMessages: {
    missingTotalSupply: "Por favor, insira um fornecimento total válido para o ano {year}.",
    missingFinalPrice: "Por favor, insira um preço final válido para o ano {year}.",
    totalSupplyExceeded: "O fornecimento total não pode exceder o fornecimento do projeto. Máximo permitido: {max}.",
    missingDescription: "Por favor, insira uma descrição para {field} no ano {year}.",
    missingForestPhoto: "Por favor, carregue uma foto da cobertura florestal para o ano {year}.",
    enterValidCosts: "Insira um custo válido maior que 0 para todos os estágios"
  },
  forestCover: {
    "1": "Floresta Tropical Úmida",
    "2": "Floresta Tropical Seca",
    "3": "Floresta de Montanha (Nublada)",
    "4": "Mata Atlântica",
    "5": "Floresta Subtropical",
    "6": "Floresta de Mangue",
    "7": "Floresta Alagada (Várzea e Igapó)",
    "8": "Mosaico de Savana e Floresta",
    "9": "Floresta Temperada",
    Dense: "Floresta Tropical Úmida"
  },
  activitiesSection: {
    activity: "Atividade",
    addActivity: "Adicionar Atividade",
    updateActivities: "Atualizar Atividades",
    activityNamePlaceholder: "Nome da Atividade",
    descriptionPlaceholder: "Descrição",
    save: "Salvar"
  },
  developerWithdrawal: {
    available: "Recursos disponíveis para retirada",
    stage: "Ano {year}, etapa {stage}",
    description: "O certificador liberou o principal desta etapa para o desenvolvedor do projeto.",
    withdraw: "Retirar",
    success: "Recursos retirados com sucesso.",
    pending: "Transação enviada. O estado da retirada está sendo atualizado.",
    failed: "Não foi possível concluir a retirada. Tente novamente.",
    unavailable: "A retirada está temporariamente indisponível. Tente novamente em instantes."
  },
  stageActions: {
    sign: "Assinar {stage}",
    withdraw: "Retirar de {stage}",
    withdrawalPendingApproval: "Retirada aguardando aprovação"
  },
  signDialog: {
    investmentProcessFinished: "Processo de investimento do projeto finalizado",
    stageRequiresAudit: "É necessário auditoria para a etapa {stage}",
    stageRequiresDeveloper: "Esta etapa requer um desenvolvedor",
    stageRequiresAuditor: "Esta etapa requer um auditor",
    stageRequiresCertifierOrDeveloper: "Esta etapa requer um {role}",
    certifier: "certificador",
    developer: "desenvolvedor",
    stageNotCompleted: "Etapa não concluída",
    withdrawSuccess: "Retirada realizada com sucesso",
    signError: "Erro ao assinar",
    remoteSensingImageHash: "Hash da Imagem de Sensoriamento Remoto",
    reportHash: "Hash do Relatório",
    deforestationRateM2: "Taxa de Desmatamento (m²)",
    landDegradationRateM2: "Taxa de Degradação do Solo (m²)",
    abovegroundCarbonStockKg: "Estoque de Carbono Acima do Solo (Kg)",
    belowgroundCarbonStockKg: "Estoque de Carbono Subterrâneo (Kg)",
    soilOrganicCarbonStockKg: "Carbono Orgânico no Solo (Kg)",
    deadOrganicMatterKg: "Matéria Orgânica Morta (Kg)",
    landUseOpportunityCost: "Custo de Oportunidade do Uso da Terra",
    leakageKg: "Fugas (Kg)",
    verifierName: "Nome do Verificador",
    verifierLicense: "Licença do Verificador",
    verificationReportHash: "Hash do Relatório de Verificação",
    verifiedEmissionReductionsKg: "Reduções de Emissão Verificadas (Kg)",
    verificationDate: "Data da Verificação",
    certificationBody: "Organismo de Certificação",
    certificationNumber: "ID da Certificação",
    certificationReport: "URL do Relatório de Certificação",
    creditsIssued: "Créditos Emitidos",
    issuanceDate: "Data de Emissão",
    creditSerialStart: "Início do Número de Série",
    creditSerialEnd: "Fim do Número de Série",
    certificationStage: "Etapa da Certificação",
    required: "Este campo é obrigatório",
    invalidNumber: "Insira um número válido",
    invalidDate: "Insira uma data válida",
    signed: "Etapa assinada com sucesso",
    withdrawn: "Etapa retirada com sucesso",
    updated: "Etapa atualizada com sucesso",
    saved: "Dados da etapa salvos",
    errorOnWithdraw: "Não foi possível concluir a retirada. Tente novamente.",
    withdrawUnavailable: "A retirada está temporariamente indisponível. Tente novamente em instantes."
  },
  investmentCostsStruct: {
    validation: {
      _label: "Custos de Validação",
      field_visit: "Visita de Campo",
      satellite_analysis: "Análise via Satélite",
      "3rd_party_validation": "Validação por Terceiros",
      "legal_&_admin": "Jurídico e Administrativo",
      certifier_registration: "Registro do Certificador",
      registration_fee: "Taxa de Registro"
    },
    monitoring: {
      _label: "Custos de Monitoramento",
      travel: "Viagem",
      "accommodation_&_meals": "Hospedagem e Alimentação",
      personnel: "Pessoal",
      data_processing: "Processamento de Dados"
    },
    verification: {
      _label: "Custos de Verificação",
      "site_visit_&_field_audit": "Visita ao Local e Auditoria de Campo",
      "report_submission_&_compliance": "Envio de Relatório e Conformidade",
      "legal_&_admin": "Jurídico e Administrativo"
    },
    issuance: {
      _label: "Custos de Emissão",
      verification_review: "Revisão da Verificação",
      carbon_credit_issuance_fee: "Taxa de Emissão de Créditos de Carbono",
      annual_fee: "Taxa Anual",
      insurance: "Seguro",
      submission_fee: "Taxa de Submissão"
    }
  },
  stageNamesAbr: {
    design: "Des.",
    validation: "Val.",
    monitoring: "Monit.",
    verification: "Verif.",
    issuance: "Cert.",
    certification: "Cert.",
    finalPrice: "Preço Final"
  },
  agroStageNamesAbr: {
    planning: "Planej.",
    site_preparation: "Preparo",
    planting: "Plantio",
    maintenance: "Manut.",
    harvest: "Colhe.",
    value_addition: "Val.Agr.",
    marketing: "Mkt.",
    finalPrice: "Preço Final",
    cultureCost: "Custos"
  },
  developerForm: {
    full_name: "Nome completo",
    email: "E-mail",
    web_page: "Página web",
    company_registry_number: "Número de registro da empresa",
    date_of_incorporation: "Data de fundação",
    phone: "Telefone",
    wallet_address: "Endereço da carteira",
    logo: "Logo da Empresa"
  },
  tokenPage: {
    fifthSectionCta: "Comece a cultivar",
    tokenSupply: "Oferta de tokens",
    tokenAmount: "850M",
    projectSize: "Tamanho atual do projeto \nem hectares",
    projectAmount: "32",
    sequestrationRate: "Taxa de sequestro de carbono \npor token",
    sequestrationAmount: "124000 ha",
    sequesterSecondLine1: "Bloqueie BCT, capture CO₂,",
    sequesterSecondLine2: "receba rendimentos do mundo real.",
    hero: {
      title: "Cultive CO₂ e ganhe créditos de carbono\ne tokens agroflorestais",
      stake: "Cultivar CO2",
      grow: "Cultive sua floresta"
    },
    thirdSection: {
      title: "Como funciona",
      gridTitle1: "1",
      gridTitle2: "2",
      gridTitle3: "3",
      gridTitle4: "4",
      gridDescription1: "Compre tokens BCT e bloqueie-os para receber recompensas",
      gridDescription2: "Os fundos dos tokens são investidos em projetos verificados.",
      gridDescription3: "Florestas capturam CO₂ gerando créditos e fazendas agroflorestais produzem cacau, açaí.",
      gridDescription4: "Receba créditos de carbono e tokens agro que podem ser convertidos em USDC."
    },
    secondSectionTitle: "Simulação de Floresta Interativa",
    secondSectionDescription: "Aumente suas recompensas cultivando sua floresta com mais de 50 espécies amazônicas, melhore a biomassa, biodiversidade e saúde do ecossistema e desbloqueie espécies raras conforme aumenta sua participação.",
    earningModelTitle: "Modelo de Ganhos e Proteção de Risco",
    earningModel: {
      item1Title: "Lastro em ativos reais",
      item1Description: "Terras e produtos agroflorestais",
      item2Title: "Receitas recorrentes",
      item2Description: "Créditos de carbono transmitidos por segundo",
      item3Title: "APR crescente",
      item3Description: "Atrelado à base de ativos em expansão"
    },
    sixthSectionTitle: "Simulação de Floresta Interativa",
    sixthSectionDescription: "“Eu adorei! Nunca tive jeito com plantas e agora sei muito sobre floresta”"
  },
  transactionActions: {
    invest: "Investir",
    buy: "Comprar",
    sell: "Vender",
    claim: "Reivindicar"
  },
  agroStageNames: {
    planning: "Planejamento e Design",
    site_preparation: "Preparação do local",
    planting: "Plantio e estabelecimento",
    maintenance: "Manutenção e cuidados",
    harvest: "Colheita e pós-colheita",
    value_addition: "Agregação de valor",
    marketing: "Marketing e distribuição",
    labor: "Mão de obra",
    inputs: "Insumos",
    tools: "Ferramentas e Equipamentos",
    services: "Serviços/Consultoria",
    infrastructure: "Infraestrutura",
    design: "Desenho",
    validation: "Validação",
    monitoring: "Monitoramento",
    verification: "Verificação",
    issuance: "Emissão",
    certification: "Certificação",
    cultureCost: "custos específicos"
  },
  agroCarbonTab: {
    revenueGrowth: "Crescimento da Receita",
    yoyGrowthRate: "Taxa de crescimento anual (YoY)",
    totalProduce: "Produção Total",
    currentProduction: "Produção Atual",
    inKg: "Em kg/ano",
    sellingPricePerKg: "Preço de Venda por Kg",
    production: "Produção"
  },
  farmerPage: {
    selectSpeciesYear: "Selecione espécie e ano",
    selectSpecies: "Selecione espécie",
    selectYear: "Selecione ano",
    selectedYear: "Ano selecionado",
    depositFor: "Depositar para",
    finalizeDepositFor: "Finalizar deposito para",
    enterDepositAmount: "Informe o valor do depósito",
    deposit: "Depositar",
    title: "Projetos do Agricultor",
    activeProjects: "Projetos ativos",
    startNewProject: "Iniciar um novo projeto",
    draftTitleFallback: "Projeto sem título",
    jobsCreated: "empregos criados",
    seeProjectPage: "Ver página",
    edit: "Editar",
    updateProduction: "Atualizar produção",
    updateStage: "Atualizar etapa",
    awaitingApproval: "Aguardando aprovação"
  },
  farmerForm: {
    enterYearlyCost: "Insira pelo menos uma entrada de custo para o ano{suffix} {years}.",
    tellUsTitle: "Conte-nos mais sobre seu projeto",
    tellUsDescription: "Se você está mantendo uma agrofloresta ancestral ou iniciando um novo sistema, este formulário nos ajuda a entender sua história, estruturar seus dados e prepará-los para investimento de impacto.",
    startApplication: "Iniciar aplicação",
    step1Title: "Envie seu projeto",
    step1Description: "Compartilhe informações básicas, espécies e dados financeiros.",
    step2Title: "Revisamos e refinamos",
    step2Description: "Nossa equipe pode entrar em contato para esclarecer ou aprimorar seus dados.",
    step3Title: "Pronto para financiamento",
    step3Description: "Após verificação, seu projeto estará apto para investimentos alinhados ao clima.",
    sidebarTitle: "Análise do Projeto",
    sidebarSubtitle: "Preencha o formulário para ver sua análise",
    submit: "Enviar",
    save: "Salvar",
    previous: "Anterior",
    continue: "Continuar",
    finishCosts: "Finalizar custos",
    nextSpecies: "Próxima espécie",
    seeAnalysis: "Ver Análise",
    stepProduction: {
      productionDelay: "Atraso na produção (meses)",
      inKg: "Em kg/ano",
      sellingPricePerKg: "Preço de venda",
      currentProduction: "Produção atual",
      currentHarvest: "Colheita atual",
      nextYearProduction: "Produção (próximo ano)",
      production: "Produção",
      years: "Anos",
      expectedAmount: "Quantidade esperada"
    },
    stepPlanting: {
      trees: "Árvores",
      plantingAreaSize: "Tamanho da Área de Plantio",
      areaPlaceholder: "00,00 hectares",
      uploadKML: "Upload do arquivo KML",
      photos: "Fotos",
      photoHint: "Inclua fotos da produção, por favor",
      speciesPlaceholder: "Nome da espécie",
      quantityPlaceholder: "Quantidade de árvores",
      addTree: "Adicionar árvore"
    },
    stepOverview: {
      speciesPlanted: "Espécies plantadas",
      expansion: "Expansão",
      maintenance: "Manutenção",
      value_addition: "Agregação de Valor",
      projectOwner: "Proprietário do projeto",
      projectOwnerPlaceholder: "Digite o proprietário do projeto",
      projectTitle: "Título do Projeto",
      projectTitlePlaceholder: "Digite o título do projeto",
      projectType: "Tipo de projeto",
      learnMore: "saiba mais",
      jobsCreated: "Número de empregos criados",
      jobsPlaceholder: "00,00",
      biome: "Bioma",
      selectBiome: "Selecione o bioma do projeto",
      speciesCount: "Número de espécies no sistema",
      speciesPlaceholder: "00,00",
      state: "Estado",
      selectState: "Selecione o estado",
      city: "Cidade",
      cityPlaceholder: "Digite a cidade",
      investment: "Investimento em R$",
      investmentCon: "Investimento em USD$",
      investmentPlaceholder: "00,00",
      projectYears: "Anos do projeto",
      yearsPlaceholder: "Digite a quantidade de anos",
      photos: "Fotos",
      photoHint: "Envie fotos da área do projeto.",
      supportingDocuments: "Documentos de apoio",
      supportingDocumentsHint: "Anexe documentos de apoio do projeto.",
      docHint: "Ex.: plano financeiro, design do plantio, mapa, fotos",
      expansionDescription: "Cria nova capacidade de produção agroflorestal.",
      maintenanceDescription: "Financia a manutenção contínua da produção existente.",
      valueAdditionDescription: "Financia processamento ou outras atividades de agregação de valor.",
      description: "Descrição do projeto",
      descriptionPlaceholder: "Digite a descrição do projeto"
    },
    stepCosts: {
      inputPlaceholder: "00,00",
      systemWide: "Sistema geral {year}",
      culture: "Cultura de {name} {year}",
      "Planning & Design": "Planejamento e Design",
      "Site preparation": "Preparação do Local",
      "Planting & establishment": "Plantio e Estabelecimento",
      "Maintenance and care": "Manutenção e Cuidados",
      "Harvest & Post-Harvest": "Colheita e Pós-Colheita",
      "Value addition": "Agregação de Valor",
      "Marketing and distribution": "Marketing e Distribuição",
      "Site Preparation": "Preparação do Local",
      "Planting & Establishment": "Plantio e Estabelecimento",
      "Maintenance & Care": "Manutenção e Cuidados",
      "Value Addition": "Agregação de Valor",
      "Marketing & Distribution": "Marketing e Distribuição",
      Labor: "Mão de Obra",
      Inputs: "Insumos",
      Materials: "Materiais",
      "Tools & Equipment": "Ferramentas e Equipamentos",
      "Services/Consultancy": "Serviços / Consultoria",
      Infrastructure: "Infraestrutura",
      repeatYearly: "Repete-se anualmente",
      recurring: "Recorrente",
      oneTime: "Pagamento único",
      toolName: "Nome do item",
      toolCost: "Custo",
      addTool: "Adicionar ferramenta ou equipamento",
      removeTool: "Remover",
      noTools: "Nenhuma ferramenta adicionada"
    },
    stepBiome: {
      deforestedArea: "Área desmatada no bioma",
      plantSpecies: "Número de espécies vegetais no bioma",
      animalSpecies: "Número de espécies animais no bioma"
    },
    stepImpact: {
      cropDiversity: "Número de culturas diferentes no sistema",
      waterAvailability: "Aumento da disponibilidade de água no solo",
      soilFertility: "Aumento da vida/fertilidade no solo",
      faunaIncrease: "Aumento da fauna na área",
      landConversion: "Conversão de pastagens ou terras agrícolas em agrofloresta",
      foodProduction: "Aumento da produção de alimentos regenerativos",
      riverbankRestoration: "Restauração da vegetação nas margens dos rios",
      carbonSequestration: "Sequestro de carbono acima/abaixo do solo",
      landConversion_placeholder: "hectares",
      foodProduction_placeholder: "toneladas/ano",
      riverbankRestoration_placeholder: "km",
      carbonSequestration_placeholder: "toneladas/ano"
    },
    stepAnalisys: {
      avgYROI: "ROI médio anual",
      increaseRevenue: "Aumento da receita",
      effectivePayback: "Período efetivo de retorno",
      monthlyPayments: "Pagamentos mensais",
      months: "meses",
      investmentCost: "Custo do investimento",
      additionalRevenue: "Receita adicional",
      safePaybackStart: "Início do retorno",
      years: "anos",
      chartTitle: "Previsão de divisão de receita",
      chartSubtitleShort: "Projetos de curto prazo dividem a receita em 50/50 até que os investidores atinjam um limite máximo de 50% de ROI.",
      chartSubtitleLong: "Projetos de longo prazo compartilham a receita enquanto o agricultor cobre os custos após os anos escolhidos.",
      farmerShare: "Parcela do agricultor",
      investorShare: "Parcela do investidor",
      yearlyBreakdownTitle: "Divisão anual de receita",
      yearlyBreakdownDescription: "Pagamentos projetados, receita líquida e divisão entre investidor e agricultor por ano.",
      yearColumn: "Ano",
      paymentsColumn: "Pagamentos",
      revenueColumn: "Receita",
      splitColumn: "Divisão de receita",
      noSplitData: "Ainda não ativo",
      acceptTerms: "Aceitar termos e condições",
      accept: "Aceitar",
      termsTitle: "Termos e Condições",
      termsText1: "Para os fins destes Termos: 'Plataforma' significa a Brazil Carbon; 'Investidor' significa a pessoa física ou jurídica que investe no Projeto por meio da Plataforma; 'Produtor' significa o agricultor identificado no cadastro do projeto; 'Área do Projeto' e 'Montante Total Exigível' são os identificados no cadastro do projeto aprovado na Plataforma.\nO Produtor emitirá em favor do Investidor uma Cédula de Produto Rural – Financeira (CPR-F), regida pela Lei nº 8.929/1994, referenciada aos produtos a serem obtidos na Área do Projeto, em valor nominal não inferior ao Montante Total Exigível. A CPR-F terá vencimentos alinhados ao calendário de colheita e será registrada perante o registrador competente ou cartório. Quando legalmente admissível, a CPR-F incluirá:\n (a) cessão fiduciária de recebíveis presentes e futuros decorrentes da venda de tais produtos; e\n (b) penhor sobre as lavouras ou os estoques da produção financiada.\nO Produtor manterá o Projeto em curso normal, seguirá as recomendações técnicas e não onerará nem alienará os bens empenhados sem o prévio consentimento por escrito do Investidor.\nTaxa de serviço: o Produtor reconhece e concorda que a Plataforma deduz uma taxa de serviço dos valores desembolsados ao Produtor, na alíquota divulgada na Plataforma no momento da contratação e registrada no contrato inteligente do Projeto.\nCustódia e disponibilidade de recursos: os recursos pendentes de desembolso são mantidos em contratos inteligentes e poderão ser temporariamente alocados em protocolos de ativos digitais de terceiros. Os desembolsos poderão ser atrasados, reduzidos ou impedidos por eventos fora do controle razoável das Partes, incluindo incidentes de segurança (ataques ou exploits) que afetem contratos inteligentes ou protocolos de terceiros, falha ou insolvência de tais protocolos, perda de paridade da stablecoin utilizada, falhas na rede blockchain e atos governamentais. Tais eventos constituem caso fortuito ou força maior (art. 393 do Código Civil), não respondendo a Plataforma nem o Investidor pelos prejuízos deles decorrentes, desde que atuem com diligência para mitigar os efeitos e recuperar os recursos.\nLimitação de responsabilidade: na máxima extensão permitida em lei, a responsabilidade agregada da Plataforma e do Investidor perante o Produtor limita-se aos danos diretos e não excederá os valores efetivamente aportados ao Projeto, excluídos danos indiretos e lucros cessantes.\nInadimplemento e prazo de cura: em caso de descumprimento pelo Produtor, o Investidor enviará notificação por escrito, e o Produtor terá 30 (trinta) dias para sanar o descumprimento antes da excussão das garantias ou do vencimento antecipado da dívida.\nAs Partes reconhecem que a coleta, o tratamento, o armazenamento e o compartilhamento de dados pessoais relativos ao Produtor e a pessoas a ele vinculadas observarão a Lei Geral de Proteção de Dados (Lei nº 13.709/2018 – LGPD). Os dados pessoais serão utilizados exclusivamente para fins relacionados à verificação do projeto, monitoramento, processamento de pagamentos, avaliação de risco e conformidade regulatória. O Produtor consente com tal tratamento e poderá solicitar acesso, correção ou exclusão de dados pessoais, conforme permitido em lei. O Investidor adotará medidas administrativas, técnicas e de segurança adequadas para proteger os dados pessoais contra acesso não autorizado, perda ou uso indevido.\nEste documento é regido pelas leis da República Federativa do Brasil. Fica eleito o foro da comarca de situação da Área do Projeto para dirimir quaisquer controvérsias. A versão em português destes Termos prevalece sobre qualquer tradução.\n",
      termsText2: "Para os fins destes Termos: 'Plataforma' significa a Brazil Carbon; 'Investidor' significa a pessoa física ou jurídica que investe no Projeto por meio da Plataforma; 'Produtor' significa o agricultor identificado no cadastro do projeto; 'Área do Projeto' e 'Montante Total Exigível' são os identificados no cadastro do projeto aprovado na Plataforma.\nTodos os maquinários, equipamentos e benfeitorias financiados nos termos deste Instrumento estarão sujeitos à alienação fiduciária de bens móveis em favor do Investidor, com eficácia mediante assinatura e registro perante o órgão competente. Até a quitação integral do Montante Total Exigível, o Produtor:\n (a) não venderá, arrendará, removerá nem onerará tais bens;\n (b) manterá os bens em boas condições de funcionamento; e\n (c) manterá seguro indicando o Investidor como primeiro beneficiário.\nEm caso de inadimplemento, e na medida permitida em lei, o Investidor poderá consolidar a posse e alienar a garantia, aplicando o produto ao saldo devedor.\nTaxa de serviço: o Produtor reconhece e concorda que a Plataforma deduz uma taxa de serviço dos valores desembolsados ao Produtor, na alíquota divulgada na Plataforma no momento da contratação e registrada no contrato inteligente do Projeto.\nCustódia e disponibilidade de recursos: os recursos pendentes de desembolso são mantidos em contratos inteligentes e poderão ser temporariamente alocados em protocolos de ativos digitais de terceiros. Os desembolsos poderão ser atrasados, reduzidos ou impedidos por eventos fora do controle razoável das Partes, incluindo incidentes de segurança (ataques ou exploits) que afetem contratos inteligentes ou protocolos de terceiros, falha ou insolvência de tais protocolos, perda de paridade da stablecoin utilizada, falhas na rede blockchain e atos governamentais. Tais eventos constituem caso fortuito ou força maior (art. 393 do Código Civil), não respondendo a Plataforma nem o Investidor pelos prejuízos deles decorrentes, desde que atuem com diligência para mitigar os efeitos e recuperar os recursos.\nLimitação de responsabilidade: na máxima extensão permitida em lei, a responsabilidade agregada da Plataforma e do Investidor perante o Produtor limita-se aos danos diretos e não excederá os valores efetivamente aportados ao Projeto, excluídos danos indiretos e lucros cessantes.\nInadimplemento e prazo de cura: em caso de descumprimento pelo Produtor, o Investidor enviará notificação por escrito, e o Produtor terá 30 (trinta) dias para sanar o descumprimento antes da excussão das garantias ou do vencimento antecipado da dívida.\nAs Partes reconhecem que a coleta, o tratamento, o armazenamento e o compartilhamento de dados pessoais relativos ao Produtor e a pessoas a ele vinculadas observarão a Lei Geral de Proteção de Dados (Lei nº 13.709/2018 – LGPD). Os dados pessoais serão utilizados exclusivamente para fins relacionados à verificação do projeto, monitoramento, processamento de pagamentos, avaliação de risco e conformidade regulatória. O Produtor consente com tal tratamento e poderá solicitar acesso, correção ou exclusão de dados pessoais, conforme permitido em lei. O Investidor adotará medidas administrativas, técnicas e de segurança adequadas para proteger os dados pessoais contra acesso não autorizado, perda ou uso indevido.\nEste documento é regido pelas leis da República Federativa do Brasil. Fica eleito o foro da comarca de situação da Área do Projeto para dirimir quaisquer controvérsias. A versão em português destes Termos prevalece sobre qualquer tradução.\n",
      termsText3: "",
      termsText4: ""
    },
    searchOrDrag: "Pesquise ou arraste e solte",
    steps: {
      information: "Informações",
      overview: "Visão Geral",
      planting: "Plantio",
      costs: "Custos",
      production: "Produção",
      analysis: "Análise",
      impact: "Impacto"
    },
    nested: {
      systemWide: "Sistema geral {year}",
      systemWideGroup: "Sistema geral",
      speciesYear: "{species} {year}",
      systemWideProd: "Sistema geral",
      species: "{species}"
    }
  },
  accountDetails: {
    back: "Voltar",
    save: "Salvar",
    wallet: "Carteira",
    legalAddress: "Endereço legal",
    registrationDate: "Data de registro",
    kyc: "KYC",
    email: "E-mail",
    verifyEmail: "Verificar e-mail",
    emailVerificationRequested: "Verificação de e-mail solicitada",
    kycVerified: "Verificado",
    kycBlocked: "Bloqueado",
    kycNotVerified: "Não verificado",
    verifyKycNow: "Verificar agora",
    kycVerificationSucceeded: "Verificação KYC concluída",
    kycVerificationFailed:
      "Não foi possível concluir a verificação KYC. Tente novamente.",
    close: "Fechar"
  },
  userSidePanel: {
    co2Farmed: "CO₂ cultivado",
    bctLocked: "BCT bloqueado",
    close: "Fechar",
    co2CapturedToday: "de CO₂ capturados hoje",
    buy: "Comprar",
    farm: "Fazenda",
    play: "Jogar",
    assets: "Ativos",
    investments: "Investimentos",
    farming: "Cultivo",
    unrealizedProfit: "Lucro não realizado",
    averagePaid: "Preço médio",
    investmentUnits: "unidades de investimento"
  },
  walletPage: {
    account: "Conta",
    export: "Exportar",
    carbonCreditsTitle: "Créditos de carbono",
    co2: "CO/2",
    cacaoTitle: "Cacau",
    acaiTitle: "Açaí",
    inProjects: "em {count} projetos",
    co2Farmed: "CO₂ cultivado",
    projectsOwned: "projetos próprios",
    assets: "Ativos",
    investments: "Investimentos",
    bctStaked: "BCT bloqueado",
    totalBct: "Total de BCT",
    transactions: "Transações",
    unavailableTitle: "Algo deu errado",
    unavailableDescription: "Não foi possível carregar seu painel agora. Tente novamente mais tarde.",
    tryAgain: "Tentar novamente",
    transactionActions: {
      BUY: "Comprar",
      SELL: "Vender",
      INVEST: "Investir",
      CLAIM: "Resgatar"
    },
  },
  stakeComponent: {
    stake: "Investir",
    unstake: "Desinvestir",
    alreadyStaked: "Já bloqueado",
    noStakes: "Sem investimentos",
    timeToUnstake: "Hora de desbloquear",
    readyToUnstake: "Pronto para desbloquear",
    login: "Conectar",
    enterAmount: "Por favor, insira um valor",
    success: "Sucesso",
    insufficientBalance: "Saldo insuficiente",
    lock: "Bloquear",
    unlock: "Desbloquear",
    durationDays: "Duração (dias)"
  },
  impactTab: {
    jobs_number: "Empregos criados",
    water_availability: "Disponibilidade de água no solo",
    soil_fertility: "Vida/fertilidade do solo",
    crop_diversity: "Diversidade de culturas",
    fauna_increase: "Fauna na região",
    land_conversion: "Conversão de pastagens ou terras agrícolas em florestas",
    regenerative_food: "Produção de alimentos regenerativos de alta qualidade",
    riverbank_regeneration: "Regeneração da floresta ao longo das margens dos rios",
    carbon_sequestration: "Sequestro de carbono acima / abaixo do solo",
    impactTabUnits: {
      none: "",
      hectares: "ha",
      tons: "t",
      co2Tons: "t de CO2"
    }
  },
  common: {
    maxFileSize: "O tamanho máximo permitido para um arquivo é {max}MB",
    dropFileHereOr: "Solte seu arquivo aqui ou",
    browse: "Procurar",
    addMoreFiles: "Adicionar mais arquivos",
    replaceFile: "Substituir arquivo",
    clearFiles: "Limpar arquivos",
    clearSelection: "Limpar seleção",
    copied: "Copiado",
    tokens: "tokens",
    claimUSDC: "Resgatar USDC",
    enterLocation: "Digite a localização",
    or: "ou",
    profileChanged: "Alterações no perfil salvas",
    selectAnOption: "Selecione uma opção",
    today: "Hoje",
    yesterday: "Ontem",
    projectSavedToDatabase: "Projeto salvo com sucesso no banco de dados",
    projectSaved: "Projeto salvo com sucesso",
    projectCreated: "Projeto criado com sucesso",
    approved: "Aprovado",
    cancel: "Cancelar",
    update: "Atualizar",
    delete: "Excluir",
    back: "Voltar",
    home: "Início",
    close: "Fechar",
    download: "Baixar"
  },
  farmerFormValidation: {
    fillBeforeProceeding: "Por favor, preencha {field} antes de prosseguir.",
    projectTitle: "Título do Projeto",
    projectDescription: "Descrição do Projeto",
    projectType: "Tipo de Projeto",
    jobsCreated: "Empregos Criados",
    biome: "Bioma",
    state: "Estado",
    city: "Cidade",
    investmentCost: "Custo do Investimento",
    projectOwner: "Proprietário do projeto",
    projectYears: "Duração do Projeto (Anos)",
    supportingDocs: "Documentos de Suporte",
    species: "Culturas Comerciais (Espécies)",
    duplicateSpecies:
      "Espécie duplicada: a mesma cultura não pode ser inserida em dois idiomas diferentes. Remova a duplicata.",
    areaSize: "Área de Plantio",
    photos: "Fotos do Projeto",
    productionDelay: "Atraso na Produção (Meses)",
    totalSupply: "Oferta Total (kg)",
    finalPrice: "Preço de Venda (por kg)",
    current: "Atual",
    year: "Ano {n}",
    systemYear: "Ano {year} do sistema",
    costLabels: {
      planning: "Planejamento e Design",
      site_preparation: "Preparação do Local",
      planting: "Plantio e Estabelecimento",
      maintenance: "Manutenção e Cuidados",
      harvest: "Colheita e Pós-Colheita",
      value_addition: "Agregação de Valor",
      marketing: "Marketing e Distribuição"
    },
    costInputs: {
      labor: "Trabalho",
      inputs: "Insumos",
      tools: "Ferramentas e Equipamentos",
      services: "Serviços/Consultoria",
      infrastructure: "Infraestrutura"
    },
    maxYearsExceeded: "A duração máxima do projeto é {max} anos. Por favor, insira um valor entre 1 e {max}."
  },
  circleLogin: {
    sendResetLink: "Enviar link de redefinição",
    forgotPassword: "Esqueceu a senha?",
    sendPasswordResetEmail: "Enviar e-mail de redefinição de senha",
    enterEmail: "Por favor, insira seu endereço de e-mail.",
    enterEmailAndPassword: "Por favor, insira seu e-mail e senha.",
    forgotPasswordMessageSent: "Se existir uma conta com esse e-mail, você receberá um link para redefinir a senha em breve.",
    resetYourPassword: "Redefinir sua senha",
    newPassword: "Nova senha",
    confirmPassword: "Confirmar senha",
    saveNewPassword: "Salvar nova senha",
    passwordResetComplete: "Sua senha foi redefinida com sucesso! Agora você pode fazer login.",
    resetFailed: "Falha na redefinição de senha. O link pode ser inválido ou ter expirado."
  },
  newTokenPage: {
    lockWithAmount: "Bloquear {amount} BCT",
    unlockWithAmount: "Desbloquear {amount} BCT",
    totalBctLocked: "Total de BCT bloqueado",
    nextSnapshotShare: "Participação de 10 mil BCT no próximo snapshot",
    rewardPreviewUnavailable: "Indisponível",
    numberProjects: "Número de projetos",
    currentProjectSize: "Tamanho atual do projeto",
    thirdSectionDescription: "Use BCT para capturar CO₂ em tempo real — transmitindo continuamente créditos de carbono e recompensas agroflorestais de cacau, açaí e muito mais.",
    growTitle: "Cultive sua floresta",
    growDescription: "Construímos um jogo idle estratégico baseado em ganância no qual os detentores de tokens cultivam, administram e expandem seus ecossistemas de floresta tropical para ganhar recompensas.",
    growEnter: "Em breve",
    growAltMain: "Ilustração da seção de crescimento",
    growAltPlant: "planta",
    growAltTimer: "cronômetro",
    growAltChart: "gráfico",
    growItemSpecies: "Modelagem realista\nde espécies",
    growItemTimer: "Crescimento autônomo\nem tempo real",
    growItemChart: "Aumento dos ganhos de créditos de carbono\nmantendo a saúde do ecossistema",
    gridItem1Title: "Bloquear tokens BCT",
    gridItem1Description: "Bloqueio de BCT (pressão de oferta) — usuários bloqueiam tokens BCT, reduzindo a oferta circulante e elevando o preço do token.",
    gridItem1RightTitle: "Comprar tokens BCT",
    gridItem2Title: "Seu bloqueio gera\nyield de Projetos Reais Verificados",
    gridItem2Description: "Investimento em Projetos Reais Verificados. Os recursos das vendas de BCT financiam diretamente projetos de carbono e agroflorestais.",
    gridItem2RightTitle: "Ver projetos",
    gridItem3Title: "Solicite o rendimento gerado na sua moeda local.",
    gridItem3Description: "Solicite diferentes rendimentos — créditos de carbono, madeira, frutas, café, cacau — em USD, EUR, BRL etc.",
    gridItem3RightTitle: "Saiba mais",
    faqTitle: "FAQ",
    faqItems: [
      {
        title: "Title",
        content: "description"
      },
      {
        title: "Title",
        content: "description"
      },
      {
        title: "Title",
        content: "description"
      }
    ],
    filterLock: "Bloquear",
    filterYield: "Rendimento",
    filterClaim: "Resgatar"
  },
  farmerCard: {
    invested: "Investido",
    deposited: "Depositado",
    stage: "Etapa",
    withdraw: "Retirar",
    withdrawUSDC: "Retirar USDC",
    updateProduction: "Atualizar produção",
    signStage: "Assinar etapa",
    finalizeSpecies: "Finalizar deposito",
    finalizeSummary: "Você está finalizando depósito para",
    harvested: "Colhido",
    harvestedAmount: "Quantidade colhida (Kg)",
    pricePerKg: "Preço de venda / Kg",
    noUsersToAllocate: "Não há usuários para alocar fundos",
    stageUnknown: "—"
  },
  calculateReturns: {
    title: "Simule seu peso de staking no V2",
    description: "Com base nos pesos atuais on-chain no próximo snapshot de financiamento de recompensas",
    yourDeposit: "BCT para staking",
    days: "{count} dias",
    nextSnapshotShare: "Participação estimada no próximo snapshot",
    ageHalfLife: "Meia-vida da idade no jogo",
    lockNow: "Fazer staking de BCT",
    rewardAsset: "Recompensas em recibos de projeto ERC-1155",
    rewardModelTitle: "Recompensas financiadas por snapshot",
    rewardModelExplanation: "Cada rodada de financiamento de recibos fixa os stakers elegíveis e seus pesos efetivos. Seu staking participa apenas das rodadas financiadas depois que ele estiver ativo.",
    noApy: "O V2 não promete APY. O financiamento futuro de recibos, os preços dos tokens de projeto e os pesos dos demais stakers são desconhecidos; as rodadas existentes mantêm o snapshot original.",
    totalStaked: "Total atual em staking",
    activeStakers: "Stakers ativos",
    fundedRounds: "Rodadas financiadas",
    configuredHalfLife: "Meia-vida configurada das recompensas",
    snapshotStatus: "Gravações de snapshot",
    snapshotReady: "Disponível",
    snapshotInProgress: "Bloqueado durante o snapshot",
    loading: "Lendo o estado atual de recompensas do V2…",
    invalidAmount: "Informe uma quantidade válida de BCT.",
    unavailable: "O estado de recompensas do V2 está indisponível."
  },
  developerRegistration: {
    introTitle: "Cadastre-se como desenvolvedor",
    introSubtitle: "Ajude-nos com uma agrofloresta ancestral ou com o lançamento de um novo sistema de floresta alimentar. Este formulário nos ajuda a entender sua história, estruturar seus dados e prepará-los para investimento de impacto.",
    getStarted: "Começar",
    noWallet: "Não tem carteira?",
    learnWallet: "Aprenda como criar uma carteira",
    formTitle: "Cadastre-se como desenvolvedor",
    fullName: "Nome completo",
    email: "E-mail",
    phoneNumber: "Telefone",
    walletAddress: "Endereço da carteira",
    connectWallet: "Conectar carteira",
    iRepresentCompany: "Represento uma empresa",
    company: "Empresa",
    companyRegistryNumber: "Número de registro da empresa",
    dateOfIncorporation: "Data de constituição",
    websiteUrl: "URL do site",
    uploadCompanyLogo: "Enviar logotipo da empresa",
    dropFilesHere: "Solte seus arquivos aqui ou",
    browse: "Procurar",
    continueToKyc: "Continuar para KYC",
    submitKycLater: "Enviar e fazer KYC depois",
    verifyTitle: "Verifique seu email",
    verifySubtitle: "Enviamos um código de verificação para o seu email. Digite o código abaixo para continuar.",
    submitCode: "Enviar código",
    requestNewCode: "Solicitar novo código",
    verificationComplete: "Verificação concluída",
    verificationMessage: "Suas informações foram verificadas com sucesso. Você já pode criar um projeto enquanto validamos sua conta.",
    createProject: "Criar projeto"
  },
  partnerPage: {
    hectares: "Hectares",
    projectType: "Tipo de Projeto",
    step1Title: "Detalhes do Projeto",
    step2Title: "Arquivos do Projeto",
    resultTitle: "Resultados",
    addProjectFiles: "Adicionar Arquivos do Projeto",
    uploadProjectPhotos: "Enviar Fotos do Projeto (Máx. 16 JPG, JPEG ou PNG)",
    uploadForestPhoto: "Enviar Foto da Cobertura Florestal (Máx. 1 JPG, JPEG ou PNG)",
    uploadProjectFiles: "Enviar Arquivos do Projeto (Máx. 4 PDF)",
    photosUploading: "Enviando Fotos...",
    filesUploading: "Enviando Arquivos...",
    upload: "Enviar",
    progress: "Progresso",
    results: "Resultados",
    projectData: "Dados do Projeto",
    noPhotos: "Não",
    images: "imagens",
    projectPhotos: "Fotos do Projeto",
    projectFiles: "Arquivos do Projeto",
    noFiles: "Não",
    pdfs: "PDFs",
    noFileUploaded: "Nenhum arquivo enviado",
    back: "Voltar",
    continue: "Continuar",
    backToProjectsList: "Voltar para a Lista de Projetos",
    finished: "Concluído!",
    nameForText: "Nome do Projeto",
    auditor: "Auditor do Projeto",
    state: "Selecionar Estado do Brasil",
    carbonCreditSupply: "Fornecimento de Crédito de Carbono",
    listingPrice: "Preço de Listagem",
    overview: "Visão Geral",
    biodiversity: "Biodiversidade",
    floraCount: "Quantidade de Espécies de Flora",
    faunaCount: "Quantidade de Espécies de Fauna",
    endangeredSpeciesCount: "Quantidade de Espécies Ameaçadas",
    userNotAuthenticated: "Usuário não autenticado",
    summary: "Resumo do Projeto",
    commission: "Comissão Parceira em USD",
    creditCommission: "Comissão Parceira em Crédito de Carbono",
    calcReddCost: "Calcular custo REDD+",
    auditorVerification: "Auditor para Verificação",
    auditorValidation: "Auditor para Validação",
    projectPartner: "Parceiro do Projeto",
    projectCertifier: "Certificador do Projeto",
    selectBrazilState: "Selecionar Estado do Brasil",
    inflationRate: "Taxa de Inflação",
    projectCoBenefitors: "Co-Beneficiários do Projeto",
    landOwner: "Proprietário da Terra",
    forestCover: "Cobertura Florestal",
    yearsPeriod: "Duração do Projeto em Anos",
    investorsPercent: "Investidores (%)",
    ownersPercent: "Proprietários (%)",
    partnersPercent: "Desenvolvedor (%)",
    platformPercent: "Plataforma (%)",
    stakersPercent: "Detentores de participação (%)",
    historicalDeforestationRate: "Taxa Histórica de Desmatamento (0-1 escala)",
    carbonSequestrationRate: "Taxa de Sequestro de Carbono (toneladas/ano)",
    deforestationDrivers: "Fatores de Desmatamento",
    deforestationAgents: "Agentes de Desmatamento",
    ecosystemServicesValuation: "Valoração dos Serviços do Ecossistema",
    biomeAreaHectares: "Área do Bioma (hectares)",
    auditorFee: "Taxa do Auditor (%)",
    auditCost: "Custo da Auditoria",
    tokenName: "Nome do Token",
    tokenSymbol: "Símbolo do Token",
    registerAsDeveloper: "Registrar-se como desenvolvedor",
    numberCarbonCredits: "Número de Créditos de Carbono"
  },
  landStatus: {
    "0": "Público",
    "1": "Privado",
    "2": "Concessão"
  }
};
